[
  {
    "key": "mower-oil-change",
    "title": "Change the mower oil",
    "why": "Engine oil breaks down with heat and run-time. A spring oil change is the cheapest engine insurance you can buy.",
    "icon": "Tractor",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["mower"] },
    "supplies": ["SAE 30 or 10W-30 (check owner's manual)", "Oil pan or drain bottle", "Funnel", "Rags"],
    "steps": [
      "Run the engine 5 minutes — warm oil drains faster and carries more crud out.",
      "Disconnect the spark plug for safety.",
      "Tip the mower with the carburetor and air filter UP (gas falls toward the engine block, not into them).",
      "Remove the drain plug or oil-fill cap and drain into the pan.",
      "Refill to the dipstick FULL mark — do not overfill. About 18-24 oz on most push mowers.",
      "Reconnect spark plug, start, run a minute, recheck oil level."
    ],
    "tips": [
      "Riding mowers and tractors: change every 50 run-hours OR yearly, whichever comes first.",
      "Old oil is recyclable at most auto-parts stores for free."
    ]
  },
  {
    "key": "riding-mower-belt-blade",
    "title": "Inspect riding mower belts + blades",
    "why": "A slipping deck belt or dull blade ruins your cut and overheats the engine. 10-minute check catches both.",
    "icon": "Settings2",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "systems": ["mower"], "system_subtypes": ["riding", "self-propelled"] },
    "supplies": ["Socket wrench", "Replacement blade if dull"],
    "steps": [
      "Disconnect the spark plug. Block the wheels.",
      "Inspect the deck belt for fraying, glazing (shiny) edges, or cracks. Replace if you see any.",
      "Remove and inspect blades. A blade that's been hit hard enough to nick deeper than a quarter-inch should be replaced, not just sharpened.",
      "Sharpen or replace, balance, reinstall to spec torque (check manual — usually 70-90 ft-lbs)."
    ],
    "tips": [
      "Buy two blades — swap a sharp one in while the dull one sharpens at the bench.",
      "Worn deck pulleys make belts fail fast. Check pulley wobble while you're in there."
    ]
  },
  {
    "key": "snow-blower-oil-change",
    "title": "Change the snow blower oil",
    "why": "Cold-start engines need clean oil to lubricate from the first pull. A fall oil change beats a no-start at 6 AM.",
    "icon": "Tractor",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["snow_blower"] },
    "supplies": ["5W-30 synthetic (cold-weather rated)", "Drain pan", "Funnel"],
    "steps": [
      "Run the engine 5 minutes to warm the oil.",
      "Locate the oil drain plug (usually bottom of the engine).",
      "Drain into the pan. Replace plug.",
      "Refill via the oil-fill tube to the FULL mark (check the dipstick).",
      "Start, run, recheck."
    ],
    "tips": [
      "5W-30 synthetic flows at -40°F — game-changing in real cold.",
      "Same time: replace the spark plug. They're $3 and matter more in cold weather."
    ]
  },
  {
    "key": "tractor-grease",
    "title": "Grease the riding mower / tractor",
    "why": "Spindles, axles, and steering joints need fresh grease yearly. Skipped grease is how you end up replacing $200 spindle assemblies.",
    "icon": "Wrench",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "systems": ["mower"], "system_subtypes": ["riding"] },
    "supplies": ["Grease gun", "Lithium-based grease (NLGI #2)"],
    "steps": [
      "Locate every zerk fitting — owner's manual will show 4-12 of them.",
      "Wipe the fitting clean before connecting the gun (dirty grease in is worse than no grease).",
      "Pump 2-3 shots into each fitting until you see fresh grease emerge at the joint.",
      "Wipe off excess."
    ],
    "tips": ["Mark a sticker inside the deck with the date — easy to verify next year."]
  },
  {
    "key": "generator-fuel-stabilizer",
    "title": "Add fuel stabilizer to the generator",
    "why": "Stored gasoline goes bad in 30-90 days, varnishing the carburetor. Stabilizer extends shelf life to a year.",
    "icon": "Zap",
    "tier": "biannual",
    "season": "fall",
    "category": "energy",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["generator"], "system_subtypes": ["portable"] },
    "supplies": ["Sta-Bil or PRI-G stabilizer"],
    "steps": [
      "Add the stabilizer dose to fresh fuel before storing.",
      "Run the generator 5 minutes to circulate stabilized fuel through the carb.",
      "Top off the tank — less air space means less moisture absorption."
    ],
    "tips": ["Ethanol-free 'rec gas' from premium pumps stores even longer and avoids ethanol corrosion."]
  },
  {
    "key": "pressure-washer-pump-oil",
    "title": "Check the pressure washer pump oil",
    "why": "Pump oil is separate from the engine oil and gets ignored. Run it dry and the pump seizes — usually a new pressure washer.",
    "icon": "Droplets",
    "tier": "biannual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["pressure_washer"] },
    "supplies": ["Pump oil per manual (often 30W non-detergent)"],
    "steps": [
      "Check the pump-oil sight glass or dipstick (separate from the engine).",
      "Top off if low; full change every 200 hours or every 2 years.",
      "Wipe down O-rings and quick-connects; lube with silicone if stiff."
    ],
    "tips": ["Drain the pump fully before freezing weather — water in the pump kills it instantly."]
  },
  {
    "key": "appliance-replace-plan",
    "title": "Plan for major appliance replacement",
    "why": "Refrigerators (~13 yrs), dishwashers (~10 yrs), and laundry pairs (~10–13 yrs) all retire about the same age. Knowing your window means you shop sales instead of emergencies.",
    "icon": "Refrigerator",
    "tier": "multi-year",
    "years_between": 12,
    "season": "any",
    "category": "indoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": [],
    "steps": [
      "Photograph the data plate on each major appliance — installed date, model, serial.",
      "Around year 8–10, watch for: rising repair frequency, energy-efficiency creep, parts becoming hard to source.",
      "Shop Black Friday + Memorial Day for the best appliance deals.",
      "Schedule delivery + haul-away together to avoid a fridge-less weekend."
    ],
    "tips": [
      "Refrigerators are the worst to lose suddenly — plan that one first.",
      "Energy Star units pay back in 4–6 years on utility savings alone."
    ]
  },
  {
    "key": "septic-pump",
    "title": "Pump the septic tank",
    "why": "Every 3–5 years is the rule for typical households. A pump every cycle is cheap insurance against a failed drain field, which is a 5-figure repair.",
    "icon": "Shovel",
    "tier": "multi-year",
    "years_between": 4,
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["septic"] },
    "supplies": [],
    "steps": [
      "Schedule a licensed pumper. Ask for a sludge level reading and baffle inspection.",
      "Avoid driving over the drain field — compaction kills the soil bacteria you depend on.",
      "Save the receipt — buyers and underwriters will ask."
    ],
    "tips": [
      "Bigger family, more usage → 3 years. Couple, low usage → 5 years. Single → up to 7.",
      "Garbage disposal owners: shorten this cycle. Solids overload the tank."
    ]
  },
  {
    "key": "termite-inspect",
    "title": "Termite inspection",
    "why": "Termites do $5 billion in damage a year in the US — almost all of it caught too late. A licensed inspector spots galleries before they're structural.",
    "icon": "Search",
    "tier": "multi-year",
    "years_between": 2,
    "season": "spring",
    "category": "structure",
    "time_minutes": 60,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": [],
    "steps": [
      "Annual is best in the South/Southwest. Northern climates can go to 2 years.",
      "Walk-around takes 30–60 minutes. Have your crawl space, basement, attic, and garage accessible.",
      "Most insurance won't cover termite damage — prevention is the whole game."
    ],
    "tips": [
      "Wood-to-soil contact (deck posts, fence boards) is the #1 entry point. Inspect those first.",
      "If you had treatment with a warranty, keep the renewal contract — most lapse silently after 5 years."
    ]
  },
  {
    "key": "smart-detector-replace",
    "title": "Replace 10-year-old smoke alarms",
    "why": "Sealed-battery and hardwired alarms expire after 10 years even if they 'work'. The sensor degrades — false alarms or no alarm.",
    "icon": "AlarmSmoke",
    "tier": "multi-year",
    "years_between": 10,
    "season": "any",
    "category": "indoor",
    "time_minutes": 45,
    "difficulty": "easy",
    "applies_to": { "systems": ["smoke"] },
    "supplies": ["Replacement alarms (combo smoke + CO recommended)"],
    "steps": [
      "Note the manufacture date on the back of each alarm.",
      "Anything older than 10 years → replace, not test.",
      "Match interconnect type (hardwired vs wireless interlink)."
    ],
    "tips": [
      "10-year sealed-battery models eliminate the annual battery swap entirely.",
      "Combination alarms (smoke + CO) reduce ceiling clutter and cover both threats with one device."
    ]
  },
  {
    "key": "pool-shock-monthly",
    "title": "Shock the pool",
    "why": "Free chlorine drops below combined chlorine, and you get the chloramine smell. A monthly shock resets the chemistry.",
    "icon": "Waves",
    "tier": "monthly",
    "season": "any",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["pool"] },
    "supplies": ["Cal-hypo or dichlor shock (1 lb per 10,000 gal)"],
    "steps": [
      "Test free vs. combined chlorine first. If combined > 0.5 ppm, you need a shock.",
      "Shock at dusk — UV burns off chlorine before it can act.",
      "Run the pump 8+ hours after shocking.",
      "Don't swim until levels drop back into normal range (test before)."
    ],
    "tips": [
      "Cloudy water after shock is normal — clarifier helps it settle faster.",
      "Heavy use (kids, parties) → shock that same evening."
    ]
  },
  {
    "key": "drainage-grading",
    "title": "Check grading around the foundation",
    "why": "Soil settles over time and slopes back toward the house. Water at the foundation is the leading cause of basement leaks and cracked slabs.",
    "icon": "Hammer",
    "tier": "annual",
    "season": "spring",
    "category": "structure",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["A 4-ft level and a tape measure"],
    "steps": [
      "Walk the perimeter. The first 6 feet of grade should drop 6 inches away from the foundation.",
      "Spots where it slopes back? Add topsoil (not mulch — mulch holds water against the wall).",
      "Check downspout extensions — they should dump water at least 6 feet from the house."
    ],
    "tips": [
      "After heavy rain, walk the basement perimeter for damp spots. Drier basement = better grading.",
      "Cracks in the foundation wider than a credit card edge are a structural conversation."
    ]
  },
  {
    "key": "furnace-filter",
    "title": "Replace the furnace filter",
    "why": "A clogged filter forces the blower to work harder — it spikes your energy bill and shortens the furnace's life.",
    "icon": "Filter",
    "tier": "quarterly",
    "season": "any",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "hvac_types": ["furnace", "heatpump"] },
    "supplies": ["A replacement filter that matches your existing size"],
    "steps": [
      "Turn the thermostat to OFF so the blower can't kick on while the slot is open.",
      "Find the filter slot — usually a metal door on the return-air duct or behind the front panel of the furnace.",
      "Note the size printed on the edge of the old filter (e.g. 16 × 25 × 1).",
      "Slide the old filter out. Note which way the airflow arrow points.",
      "Slide the new filter in matching that same arrow direction (toward the furnace).",
      "Write today's date on the new filter's frame so you remember next time."
    ],
    "tips": [
      "MERV 8–11 is the sweet spot for most homes. Higher MERV traps more but restricts airflow.",
      "Pets, allergies, or new construction? Check monthly — they clog filters fast."
    ]
  },
  {
    "key": "smoke-co-test",
    "title": "Test smoke & CO alarms",
    "why": "Press-and-hold the test button on each unit. This is the single highest-leverage safety task in your home.",
    "icon": "AlarmSmoke",
    "tier": "quarterly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Step stool", "Fresh 9V or AA batteries on standby"],
    "steps": [
      "Walk room by room. Press and hold the test button on each alarm for 5 seconds — it should sound.",
      "If it chirps weakly instead of full alarm, the battery is dying — replace it.",
      "Vacuum dust off the alarm grilles while you're up there.",
      "Note the manufacture date on the back. Alarms expire after 10 years even if they 'work'."
    ],
    "tips": [
      "Code says at least one per bedroom, one per floor, and outside sleeping areas.",
      "Combination smoke + CO alarms count for both — simpler to maintain."
    ]
  },
  {
    "key": "water-heater-flush",
    "title": "Flush the water heater",
    "why": "Sediment settles in the tank, cooks against the heating element, and steals capacity. A yearly flush adds real years.",
    "icon": "ShowerHead",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "systems": ["wh"], "system_subtypes": ["tank"] },
    "supplies": ["Garden hose", "Bucket", "Channel-lock pliers"],
    "steps": [
      "Turn the thermostat to OFF (electric) or pilot/vacation (gas).",
      "Close the cold-water supply valve at the top of the tank.",
      "Connect a hose to the drain valve at the bottom; run it to a floor drain or outside.",
      "Open a hot tap upstairs — this breaks the vacuum so water can flow out.",
      "Open the drain valve. Let it run until the water comes out clear (5–15 min).",
      "Close the drain, remove the hose, open the cold-supply valve, and wait for the upstairs tap to run smoothly before relighting/turning on."
    ],
    "tips": [
      "Skip this on a tankless unit — they need a descaling kit instead (annual, vinegar flush).",
      "If the drain valve seems stuck or won't reseal, that's a sign the tank is near end-of-life."
    ]
  },
  {
    "key": "tankless-descale",
    "title": "Descale the tankless water heater",
    "why": "Mineral scale on the heat exchanger drops efficiency and eventually triggers error codes. A yearly vinegar flush is the manufacturer-recommended fix.",
    "icon": "FlaskConical",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["wh"], "system_subtypes": ["tankless"] },
    "supplies": ["3–4 gallons of white vinegar", "Submersible pump", "Two short hoses", "Bucket"],
    "steps": [
      "Cut power and gas to the unit.",
      "Close the hot and cold isolation valves.",
      "Connect hoses to the service ports, route through the pump in a bucket of vinegar.",
      "Open the service valves and run the pump for 45–60 minutes.",
      "Drain vinegar, flush with fresh water for 5 minutes, restore valves and power."
    ],
    "tips": [
      "Hard-water homes may need this every 6 months — descale kits are inexpensive on Amazon.",
      "Take a photo of the valve positions before you change anything so you can put them back exactly."
    ]
  },
  {
    "key": "dishwasher-clean",
    "title": "Run a dishwasher cleaning cycle",
    "why": "Grease and food bits build up in the spray arms and filter. A monthly clean cycle keeps dishes coming out actually clean.",
    "icon": "Utensils",
    "tier": "monthly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["dw"] },
    "supplies": ["Dishwasher cleaning tablet (or 1 cup of white vinegar)"],
    "steps": [
      "Empty the dishwasher.",
      "Pull out the bottom rack and remove the filter (twist out at the base of the spray arm).",
      "Rinse the filter under hot water; scrub with an old toothbrush if needed.",
      "Place the cleaning tablet in the detergent cup, or set a cup of vinegar upright in the top rack.",
      "Run the hottest cycle, empty, done."
    ],
    "tips": [
      "If your dishes come out gritty, the filter is the first thing to check.",
      "Lift the door seal and wipe — black gunk lives there and it's gross but easy."
    ]
  },
  {
    "key": "humidifier-pad",
    "title": "Replace whole-home humidifier pad",
    "why": "Mineral buildup blocks evaporation — the unit runs but adds no moisture, and you're paying for water you can't feel.",
    "icon": "Wind",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": { "systems": ["humid"] },
    "supplies": ["Replacement humidifier pad matching your model number"],
    "steps": [
      "Turn the humidistat all the way down.",
      "Shut off the water supply valve to the humidifier.",
      "Open the unit cover, lift the old pad out, drop the new one in oriented the same way.",
      "Restore water, turn the humidistat back to 35–40%.",
      "Watch for a leak in the first hour — the drain line can clog over the summer."
    ],
    "tips": [
      "Hard-water homes may need 2 pads per heating season.",
      "Aim for 30–40% RH. Higher than 45% can drip on windows and grow mold."
    ]
  },
  {
    "key": "fridge-coils",
    "title": "Vacuum refrigerator coils",
    "why": "Dust insulates the coils, the compressor runs longer, and that's real electricity. Five minutes saves money for years.",
    "icon": "Refrigerator",
    "tier": "biannual",
    "season": "any",
    "category": "indoor",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["fridge"] },
    "supplies": ["Vacuum with brush attachment"],
    "steps": [
      "Pull the fridge away from the wall (or pop the toe-kick grille at the front).",
      "Vacuum the dust off the coils and the floor underneath.",
      "Wipe the gasket around the door while you're back there — it's a sealing surface that benefits from cleaning."
    ],
    "tips": [
      "Pets? Do this every 3 months instead. Hair builds up fast.",
      "If the fridge motor sounds louder than usual, dirty coils are the first suspect."
    ]
  },
  {
    "key": "range-hood-filter",
    "title": "Clean the range hood filter",
    "why": "Grease in the filter is a fire risk and chokes airflow. The dishwasher does almost all the work.",
    "icon": "Fan",
    "tier": "quarterly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["hood"] },
    "supplies": ["Dishwasher detergent or degreaser"],
    "steps": [
      "Slide the metal grease filter out of the hood (usually a finger tab).",
      "Lay it flat in the bottom rack of the dishwasher.",
      "Run the hottest cycle — it'll come out clean.",
      "Dry, slide back in."
    ],
    "tips": [
      "If your hood vents outside, also pull the cover off and wipe the duct flap — it sticks closed and kills airflow.",
      "Charcoal-filter (recirculating) hoods need filter replacement, not washing — check your manual."
    ]
  },
  {
    "key": "chimney-inspection",
    "title": "Have the chimney inspected",
    "why": "Creosote buildup is the #1 cause of chimney fires. A CSIA-certified sweep catches it before it ignites.",
    "icon": "Flame",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["fire"], "system_subtypes": ["wood", "wood-stove", "pellet"] },
    "supplies": ["A reputable local chimney sweep"],
    "steps": [
      "Search 'CSIA-certified chimney sweep near me' — that certification matters.",
      "Schedule before peak season ($150–300 typical for inspection + sweep).",
      "Ask for a Level 1 inspection (visual). Upgrade to Level 2 if you've had a chimney fire or moved into a new home.",
      "Save the report — it's leverage at resale."
    ],
    "tips": [
      "Burn seasoned hardwood only. Pine and unseasoned wood put creosote down 5× faster.",
      "A glass door looks clean before the flue does. Sweep is by frequency of use, not appearance."
    ]
  },
  {
    "key": "gas-fireplace-service",
    "title": "Service the gas fireplace",
    "why": "Pilot, thermocouple, and log placement drift over a year of use. A pro tune-up keeps the flame even and the safety pilot honest.",
    "icon": "Flame",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["fire"], "system_subtypes": ["gas", "gas-ventless"] },
    "supplies": ["Gas-fireplace tech (yearly)"],
    "steps": [
      "Schedule before heating season starts.",
      "Tech inspects the burner, pilot, thermopile, gasket, and (for vented) the chimney terminator.",
      "For ventless: tech checks the oxygen-depletion sensor (ODS) — this is the only thing keeping CO from accumulating in the room.",
      "Wipe glass with a dedicated fireplace-glass cleaner; standard glass cleaner can leave streaks that burn in."
    ],
    "tips": [
      "Ventless units: pair them with a battery-backup CO alarm in the same room.",
      "Smell rotten eggs in summer? The pilot may have gone out — a tech can confirm safely."
    ]
  },
  {
    "key": "electric-fireplace-clean",
    "title": "Clean the electric fireplace",
    "why": "Dust on the heating element makes it smell when you first turn it on. A 10-minute clean each season fixes that.",
    "icon": "Flame",
    "tier": "biannual",
    "season": "fall",
    "category": "indoor",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["fire"], "system_subtypes": ["electric"] },
    "supplies": ["Vacuum with brush attachment", "Microfiber cloth"],
    "steps": [
      "Unplug or shut off at the breaker.",
      "Vacuum the heater intake grille and the LED flame box.",
      "Wipe the glass front with a microfiber — no harsh cleaners.",
      "Plug back in and run for 10 min to burn off any settled dust."
    ],
    "tips": [
      "If the fan rattles, dust on the squirrel-cage is the usual culprit.",
      "These units are basically space heaters — make sure the circuit isn't shared with sensitive electronics."
    ]
  },
  {
    "key": "fans-reverse-winter",
    "title": "Reverse ceiling fans for winter",
    "why": "Clockwise rotation pushes warm air down from the ceiling. Real heating-bill savings, free to do.",
    "icon": "RotateCw",
    "tier": "biannual",
    "season": "fall",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["fans"] },
    "supplies": ["Step stool"],
    "steps": [
      "Turn the fan off and wait until it stops.",
      "Find the small directional switch on the motor housing (or use the remote).",
      "Flip to clockwise (looking up at the blades). Run on low.",
      "You shouldn't feel a draft — you should feel a temperature change after a few minutes."
    ],
    "tips": [
      "Low speed only in winter. High speed creates a windchill effect you don't want.",
      "Dust the blades with a pillowcase before flipping the switch."
    ]
  },
  {
    "key": "fans-reverse-summer",
    "title": "Reverse ceiling fans for summer",
    "why": "Counter-clockwise creates the cooling breeze you want. Let the fan earn its keep before AC does all the work.",
    "icon": "RotateCcw",
    "tier": "biannual",
    "season": "spring",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["fans"] },
    "supplies": [],
    "steps": [
      "Flip the directional switch back to counter-clockwise.",
      "Run on medium or high while occupied; off when you leave the room (it doesn't cool the room, it cools you)."
    ],
    "tips": ["A 78°F room with a fan feels like 74°F to a person — bump your thermostat up 4°F when fans are running."]
  },
  {
    "key": "softener-salt",
    "title": "Top off the water softener salt",
    "why": "Run out of salt and you're back to hard water — and a softener that's straining its resin bed.",
    "icon": "Box",
    "tier": "monthly",
    "season": "any",
    "category": "systems",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["soft"] },
    "supplies": ["40-lb bag of softener salt pellets (not table salt)"],
    "steps": [
      "Open the brine tank lid.",
      "Salt should be at least 3–4 inches above the water line. If you can see crusted salt above clear water, that's a 'salt bridge' — break it up with a broom handle.",
      "Add a bag if it's low. Don't overfill — leave headroom for the next refill."
    ],
    "tips": [
      "Use pellets, not crystals — pellets are cleaner and bridge less.",
      "If you're going through bags fast, your hardness setting may be too high or the resin is failing."
    ]
  },
  {
    "key": "sump-pump-test",
    "title": "Test the sump pump",
    "why": "Pour a bucket of water in. If it doesn't kick on, you'd rather know now than at 2 AM during a storm.",
    "icon": "Activity",
    "tier": "biannual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["sump"] },
    "supplies": ["A 5-gallon bucket"],
    "steps": [
      "Slowly pour water into the sump pit until the float rises.",
      "The pump should kick on, eject the water, and shut off within a few seconds of the float dropping.",
      "Listen for grinding or whining — both indicate worn bearings."
    ],
    "tips": [
      "If you have a battery backup pump, test it too — unplug the primary first to force the backup to run.",
      "Sumps near concrete dust get clogged float switches. Lift the pump and rinse the float annually."
    ]
  },
  {
    "key": "disposal-clean",
    "title": "Freshen the garbage disposal",
    "why": "Built-up food residue is what makes it smell. Ice and citrus knock it loose without chemicals.",
    "icon": "Soup",
    "tier": "monthly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["disp"] },
    "supplies": ["A few cups of ice cubes", "A lemon or lime wedge"],
    "steps": [
      "Run cold water on full.",
      "Drop a tray of ice cubes in, then run the disposal — they knock gunk off the blades.",
      "Drop in a citrus wedge and run another 15 seconds for the smell."
    ],
    "tips": [
      "Never put bones, pits, eggshells, celery, or pasta down a disposal — they're the top jam-makers.",
      "Use cold water, not hot. Cold solidifies grease so it grinds away instead of coating the trap."
    ]
  },
  {
    "key": "washer-clean",
    "title": "Clean the washing machine",
    "why": "Detergent residue grows mildew, especially on front-loaders. A monthly clean cycle prevents the smell that ruins clean clothes.",
    "icon": "WashingMachine",
    "tier": "monthly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["washer"] },
    "supplies": ["Affresh tablet OR 1 cup white vinegar + 1/2 cup baking soda"],
    "steps": [
      "Run a 'Clean Washer' cycle if your model has one — otherwise hottest water + extra rinse.",
      "Add the tablet to an empty drum (or vinegar to the detergent dispenser + baking soda to the drum).",
      "After the cycle, leave the door open to dry. This single habit prevents 90% of musty smells.",
      "Pull the detergent drawer and rinse it under hot water — slime lives in there."
    ],
    "tips": [
      "Front-loaders: wipe the rubber gasket dry weekly with a kitchen towel. That's the #1 mildew zone.",
      "Use less detergent than the label says — modern machines need a fraction."
    ]
  },
  {
    "key": "dryer-vent",
    "title": "Clean the dryer vent line",
    "why": "Lint in the exhaust is the leading cause of dryer fires and the reason your dryer runs twice as long as it should.",
    "icon": "Flame",
    "tier": "annual",
    "season": "fall",
    "category": "indoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["dryer"] },
    "supplies": ["Dryer-vent brush kit (looks like a chimney sweep, $20)", "Vacuum with crevice tool"],
    "steps": [
      "Unplug the dryer (or shut off gas). Pull it forward.",
      "Disconnect the flexible duct from the back of the dryer.",
      "Run the brush kit through the duct from inside the house, working out to the exterior hood.",
      "Vacuum the lint that falls out of both ends.",
      "Check the exterior vent flap — it should open freely and close fully. Replace if cracked.",
      "Reconnect, push the dryer back, restore power."
    ],
    "tips": [
      "Long or twisty vent runs (over 25 feet)? Do this every 6 months.",
      "If you ever smell 'dryer-warm' air upstairs and the dryer's running, the duct has a leak."
    ]
  },
  {
    "key": "lint-trap-weekly",
    "title": "Clean the dryer lint trap",
    "why": "Pulling the visible lint is just step one. A film from dryer sheets blocks airflow even with a 'clean' trap.",
    "icon": "Trash2",
    "tier": "weekly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["dryer"] },
    "supplies": ["Soapy water (every few months)"],
    "steps": [
      "Pull the lint screen, peel the lint off, discard.",
      "Every 3 months: rinse the screen under the faucet. Water should pass through freely — if it beads up, scrub with soap.",
      "Air dry before reinserting."
    ],
    "tips": ["If clothes are still damp after a normal cycle, the lint trap or the vent is the first suspect — not the dryer itself."]
  },
  {
    "key": "boiler-service",
    "title": "Schedule annual boiler service",
    "why": "A tech checks pressure, vents, expansion tank, and burner combustion. Cheapest insurance against a no-heat call in January.",
    "icon": "Wrench",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 120,
    "difficulty": "hard",
    "applies_to": { "hvac_types": ["boiler"] },
    "supplies": ["A reputable hydronics technician"],
    "steps": [
      "Schedule before heating season — techs are booked solid by October.",
      "Ask for combustion analysis (digital readout), expansion-tank pressure check, and a pressure-relief-valve test.",
      "Bleed your radiators after the service if heat is uneven."
    ],
    "tips": [
      "Boiler pressure should sit around 12–15 psi cold. Too high = bad expansion tank.",
      "If you have a backflow preventer, the service should include a leak check on it."
    ]
  },
  {
    "key": "heatpump-filter",
    "title": "Clean the heat-pump filter",
    "why": "Heat pumps move air constantly — a dirty filter cuts capacity fast in both heating and cooling modes.",
    "icon": "Filter",
    "tier": "monthly",
    "season": "any",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "hvac_types": ["heatpump", "mini"] },
    "supplies": ["Soft brush", "Vacuum"],
    "steps": [
      "Each indoor head: pop the front cover open.",
      "Slide the screen filter(s) out, vacuum or rinse under cool water.",
      "Dry fully before sliding back in. Wipe the front cover while it's open."
    ],
    "tips": [
      "Mini-splits with no central return have very tiny filters — clean monthly, no exceptions.",
      "If a head ices over outdoors in winter, defrost mode is normal — don't pour water on it."
    ]
  },
  {
    "key": "ac-condenser-clean",
    "title": "Wash the AC / heat-pump condenser",
    "why": "Leaves and dust on the outdoor fins reduce heat exchange. Better airflow = lower summer bills and longer compressor life.",
    "icon": "Fan",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "hvac_types": ["furnace", "heatpump"] },
    "supplies": ["Garden hose", "Coil cleaner (optional)"],
    "steps": [
      "Shut off the disconnect box mounted next to the unit.",
      "Clear leaves, sticks, and grass clippings from around the base (allow 2 ft clearance).",
      "Spray the fins from inside-out if possible (top down if not). Use low-medium pressure.",
      "Let it dry, restore power, run a cooling cycle to confirm normal operation."
    ],
    "tips": [
      "Bent fins can be straightened with a fin comb ($10) — they affect airflow more than you'd think.",
      "Cottonwood trees and pet hair are condenser killers. Inspect more often if you have either."
    ]
  },
  {
    "key": "thermostat-schedule",
    "title": "Review the thermostat schedule",
    "why": "A schedule that matches your actual day saves real money. Setbacks of 7–10°F for 8 hours yield ~10% on heating/cooling.",
    "icon": "Thermometer",
    "tier": "biannual",
    "season": "any",
    "category": "energy",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["thermostat"] },
    "supplies": [],
    "steps": [
      "Open the schedule on the thermostat or its app.",
      "Set a wake / away / home / sleep profile that matches your actual routine.",
      "If it learns automatically (Nest, Ecobee), check the History — it'll show whether the auto-schedule matches reality."
    ],
    "tips": [
      "Heat-pump homes: avoid setbacks larger than 4°F. Aux heat kicks in hard on recovery and erases the savings.",
      "Vacation mode pays for itself the first time you use it."
    ]
  },
  {
    "key": "gutter-clean-fall",
    "title": "Clean the gutters",
    "why": "Clogged gutters back water under the roof edge and into the fascia. That repair is the most expensive thing on this list — easily $3–5k.",
    "icon": "Wrench",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["gutters"] },
    "supplies": ["Stable extension ladder", "Gutter scoop or trowel", "Bucket", "Garden hose"],
    "steps": [
      "Wait until most leaves have fallen — too early and you'll do it twice.",
      "Position the ladder on level ground, never on the gutter itself.",
      "Scoop debris into the bucket. Save the worst for the downspout opening.",
      "Flush each section with the hose toward the downspout.",
      "Tap the downspout — if water pools, a snake or wet-vac from the bottom usually clears it.",
      "Inspect the brackets — loose ones turn into expensive ones after a snow load."
    ],
    "tips": [
      "Hire it out if you're not comfortable on a ladder. $100–200 for a typical 2-story is cheap relative to the fall risk.",
      "If you see paint flaking on the soffit, water has been getting in for a while — investigate before it's structural."
    ]
  },
  {
    "key": "gutter-check-spring",
    "title": "Check gutters after winter",
    "why": "Ice, snow load, and wind loosen brackets and pull gutters away from the fascia. A walk-around now beats a leak in May.",
    "icon": "SearchCheck",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["gutters"] },
    "supplies": [],
    "steps": [
      "Walk the perimeter on a clear day.",
      "Look for sags, pulled-away seams, or downspouts that detached.",
      "Note anything that needs ladder work and budget it before the spring rains."
    ],
    "tips": ["Most gutter brackets fail at the same anchor — when you replace one, replace its neighbor preemptively."]
  },
  {
    "key": "roof-inspection",
    "title": "Inspect the roof",
    "why": "Catching one missing or curled shingle now is a $20 fix. Letting it leak through the deck is a 5-figure repair.",
    "icon": "Home",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "systems": ["roof"] },
    "supplies": ["Binoculars", "Phone for photos"],
    "steps": [
      "Walk the perimeter at ground level. Use binoculars to scan each slope.",
      "Look for: missing or curled shingles, granule loss in the gutters, lifted flashing around chimneys and vents, daylight at the soffit edges.",
      "Photograph anything concerning. Compare to last year's photos.",
      "If you see any of the above, get a free roofer quote before the next storm."
    ],
    "tips": [
      "Don't walk the roof unless you know what you're doing — falls kill more homeowners than fires.",
      "After hail or 60+ mph winds, get a contractor inspection — many problems aren't visible from the ground."
    ]
  },
  {
    "key": "lawn-fertilize",
    "title": "Fertilize the lawn (spring)",
    "why": "Early-spring feeding kicks growth and crowds out weeds before they germinate. The pre-emergent half of this matters more than the fertilizer half.",
    "icon": "Sprout",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "easy",
    "applies_to": { "systems": ["lawn"] },
    "supplies": ["Pre-emergent + slow-release nitrogen fertilizer (e.g. Scotts Step 1)", "Broadcast or drop spreader"],
    "steps": [
      "Time it for when forsythia blooms in your area — that's the magic crabgrass-prevention window.",
      "Calibrate the spreader to the bag's recommended setting.",
      "Walk parallel lines edge-to-edge, then perpendicular for full coverage.",
      "Water in within 48 hours unless rain is coming."
    ],
    "tips": [
      "Mow before you fertilize, not after.",
      "Skip pre-emergent on areas you plan to overseed — it stops new grass too."
    ]
  },
  {
    "key": "lawn-overseed",
    "title": "Overseed thin lawn areas (fall)",
    "why": "Cool-season grasses germinate fastest in early fall — soil is warm, nights are cool, weeds are slowing down.",
    "icon": "Sprout",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["lawn"] },
    "supplies": ["Grass seed matched to your sun/shade conditions", "Starter fertilizer", "Straw or compost topdressing (thin)"],
    "steps": [
      "Mow the existing grass shorter than usual (1.5–2 inches) to give seeds light.",
      "Rake bare spots to loosen the top quarter-inch of soil.",
      "Apply seed, then starter fertilizer, then a thin top-dressing of compost.",
      "Water lightly twice a day for 2 weeks — keep the seed surface damp, not soaked."
    ],
    "tips": [
      "Don't use pre-emergent in spring if you plan to overseed in fall — it'll still inhibit germination 6 months later.",
      "First mow at 3.5 inches once new grass is 4 inches tall."
    ]
  },
  {
    "key": "irrigation-winterize",
    "title": "Winterize the irrigation system",
    "why": "Water left in PVC lines splits when it freezes. The repair is mid-winter, expensive, and underground.",
    "icon": "Snowflake",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "systems": ["irrig"] },
    "supplies": ["Air compressor (50+ CFM) — or hire a blowout service for $75–125"],
    "steps": [
      "Shut off the water supply to the system.",
      "Connect the compressor to the blowout port (downstream of the backflow preventer).",
      "Open one zone at a time, blow until only mist comes out — then move to the next.",
      "Never run the compressor with no zone open or you'll blow the backflow.",
      "Drain the backflow preventer last."
    ],
    "tips": [
      "Small homeowner compressors aren't big enough — most folks hire this out, and it's worth it.",
      "Mark the calendar for spring startup so you remember the steps in reverse."
    ]
  },
  {
    "key": "irrigation-startup",
    "title": "Start up the irrigation system",
    "why": "Pressurize lines slowly and walk every zone — winter damage shows up immediately and is fixable now.",
    "icon": "Droplets",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "systems": ["irrig"] },
    "supplies": [],
    "steps": [
      "Open the main valve slowly — half-turn, wait, half-turn. Pressurizing fast is what blows heads.",
      "Run each zone for 2–3 minutes. Walk it.",
      "Look for: missing heads (frost-heaved), geysers (broken pipe), brown patches that aren't getting water, heads that won't pop up.",
      "Adjust heads to spray pavement-free where possible.",
      "Set the controller for spring — typically 20–30 min twice a week, early morning."
    ],
    "tips": ["A wifi controller pays back fast — it skips zones when it rains and adjusts seasonally on its own."]
  },
  {
    "key": "deck-seal",
    "title": "Re-seal the deck",
    "why": "Sealer is what stops boards from cupping, splintering, and rotting. Skip a year and you start replacing boards.",
    "icon": "PaintBucket",
    "tier": "multi-year",
    "years_between": 2,
    "season": "summer",
    "category": "outdoor",
    "time_minutes": 180,
    "difficulty": "hard",
    "applies_to": { "systems": ["deck"] },
    "supplies": ["Deck cleaner", "Stiff brush or scrub pad", "Stain/sealer", "Brush, roller, and/or sprayer"],
    "steps": [
      "Sweep and pressure-wash (low pressure!) or scrub clean with deck cleaner. Let dry 48 hours.",
      "Inspect: replace cracked boards and reset any popped screws.",
      "Apply stain/sealer with a sprayer, back-brush into the wood with a brush.",
      "Two thin coats beat one thick coat — second coat after the first is dry to touch."
    ],
    "tips": [
      "Composite decks: no sealer; just a yearly composite cleaner.",
      "Sealer fails first on horizontal surfaces with full sun — those need attention every year."
    ]
  },
  {
    "key": "deck-inspect",
    "title": "Inspect the deck",
    "why": "Loose railings, hidden joist rot, and rusted ledger flashing are the failure modes. Catch them at $20 not $20,000.",
    "icon": "SearchCheck",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["deck"] },
    "supplies": ["Screwdriver to probe soft spots"],
    "steps": [
      "Lean against each railing post — they should feel rigid.",
      "Probe the ledger board (where the deck meets the house) with a screwdriver. Soft? Get an inspector.",
      "Check joist hangers and lag bolts for rust.",
      "Look under the deck for any signs of dry rot at the corners."
    ],
    "tips": ["Decks over 15 years old built without flashing under the ledger have a real failure risk. Worth a pro look."]
  },
  {
    "key": "septic-inspect",
    "title": "Inspect the septic system",
    "why": "A yearly check of the tank level catches a problem at $100 instead of $5,000. Pumping cycle is every 3–5 years for most households.",
    "icon": "Shovel",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "systems": ["septic"] },
    "supplies": ["A septic service company"],
    "steps": [
      "Schedule the service. They open the tank, measure scum and sludge layers, and check the inlet/outlet baffles.",
      "Ask whether the tank needs pumping (most companies recommend at 30% sludge volume).",
      "Note the date and findings — this is your record at resale."
    ],
    "tips": [
      "Don't drive over the drain field — compaction kills the soil's ability to absorb effluent.",
      "Garbage disposals double the rate of solids hitting your tank. Use sparingly if you're on septic."
    ]
  },
  {
    "key": "well-water-test",
    "title": "Test the well water",
    "why": "Bacteria, nitrates, and pH should be checked yearly — kits are cheap, labs are local, and findings catch issues before they're chronic.",
    "icon": "TestTube",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["wellw"] },
    "supplies": ["Test kit from your county health dept. or a lab"],
    "steps": [
      "Call the county health dept. or search 'well water test kit [county] [state]' — many counties subsidize or test for free.",
      "Follow the kit instructions exactly — sampling errors render the test useless.",
      "Ship within the window, save the results."
    ],
    "tips": [
      "If you have an infant, pregnant person, or someone immunocompromised in the house, test twice a year.",
      "After any work on the well, run a bacteria-only test before drinking."
    ]
  },
  {
    "key": "pool-open",
    "title": "Open the pool",
    "why": "Cover off, chemistry balanced, pump running before algae sets in. A clean opening is a clean season.",
    "icon": "Waves",
    "tier": "annual",
    "season": "spring",
    "keyed_event": "last_frost",
    "days_offset": 30,
    "category": "outdoor",
    "time_minutes": 120,
    "difficulty": "moderate",
    "applies_to": { "systems": ["pool"] },
    "supplies": ["Pool cover pump or wet vac", "Start-up chemical kit", "Test strips"],
    "steps": [
      "Pump standing water off the cover before pulling it.",
      "Remove and clean the cover; store it dry.",
      "Reattach skimmer baskets, return jets, ladder, and any removed fittings.",
      "Fill to mid-skimmer, prime the pump, run the filter.",
      "Test water, add start-up chemicals per the kit. Shock at night for best kill."
    ],
    "tips": [
      "If you opened to a green pool, brush and shock — clearing takes a few days, don't panic.",
      "Replace your sand or cartridge every 5–7 years; DE every season."
    ]
  },
  {
    "key": "pool-close",
    "title": "Close the pool",
    "why": "Lower the water below the skimmer, winterize chemicals, blow out the lines. A bad closing is a green pool in April.",
    "icon": "Snowflake",
    "tier": "annual",
    "season": "fall",
    "keyed_event": "first_frost",
    "days_offset": -14,
    "category": "outdoor",
    "time_minutes": 120,
    "difficulty": "moderate",
    "applies_to": { "systems": ["pool"] },
    "supplies": ["Winterizing chemical kit", "Skimmer plug + return-jet plugs", "Cover"],
    "steps": [
      "Lower water to below the skimmer (typical: 6 inches below in northern climates).",
      "Add winterizing kit per directions, run pump for an hour to circulate.",
      "Blow out the lines with a shop vac (or compressed air) and plug them.",
      "Remove drain plugs from the pump and filter — leave them off all winter.",
      "Pull skimmer baskets, return jets; cover the pool."
    ],
    "tips": [
      "Antifreeze for pools (-100°F propylene glycol) goes in the skimmer lines, not the pool itself.",
      "If you have a heater, drain it completely or you'll crack the heat exchanger."
    ]
  },
  {
    "key": "pool-weekly",
    "title": "Pool weekly check",
    "why": "30 minutes a week keeps the water clean and chemicals stable. Skipped weeks turn into expensive shocks.",
    "icon": "Waves",
    "tier": "weekly",
    "season": "summer",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["pool"] },
    "supplies": ["Test strips", "Skimmer net", "Vacuum head + hose"],
    "steps": [
      "Skim leaves and bugs off the surface.",
      "Brush the walls and waterline.",
      "Vacuum the floor (manual or robot).",
      "Empty skimmer and pump baskets.",
      "Test the water. Adjust chlorine, pH, alkalinity per the strip."
    ],
    "tips": ["Free chlorine 2–4 ppm, pH 7.4–7.6, alkalinity 80–120. Memorize this triangle."]
  },
  {
    "key": "hottub-weekly",
    "title": "Hot tub weekly check",
    "why": "Hot water + bodies = bacteria heaven without chemical balance. A weekly check keeps the water safe to soak in.",
    "icon": "Waves",
    "tier": "weekly",
    "season": "any",
    "category": "outdoor",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["hottub"] },
    "supplies": ["Test strips", "Sanitizer (chlorine or bromine)"],
    "steps": [
      "Test water before the first soak each week.",
      "Adjust pH (7.4–7.6) and sanitizer (free chlorine 3–5 or bromine 4–6 ppm).",
      "After use: drop a small dose of shock to oxidize sweat and oils.",
      "Drain and refill every 3 months."
    ],
    "tips": ["Filter cartridge: rinse weekly, chemically clean monthly. Replace every 1–2 years."]
  },
  {
    "key": "driveway-seal",
    "title": "Seal-coat the asphalt driveway",
    "why": "A fresh seal coat doubles asphalt life. Pick a hot, dry stretch with no rain in the 48-hour forecast.",
    "icon": "SquareDashed",
    "tier": "multi-year",
    "years_between": 3,
    "season": "summer",
    "category": "outdoor",
    "time_minutes": 240,
    "difficulty": "moderate",
    "applies_to": { "systems": ["driveway"] },
    "supplies": ["Driveway sealer (one 5-gal bucket per ~250 sq ft)", "Squeegee + brush combo", "Crack filler"],
    "steps": [
      "Sweep and pressure-wash the driveway. Let dry 24 hours.",
      "Fill any cracks wider than a pencil with crack filler.",
      "Mix the sealer (stir from the bottom). Pour a small puddle, spread with the squeegee in long strokes.",
      "Apply 2 thin coats with 4+ hours between.",
      "Block the driveway for 24–48 hours. Cars stay off."
    ],
    "tips": [
      "Stamp 'SEAL COAT' in your phone calendar 3 years out — that's the cadence.",
      "If you see white powder dusty residue, the asphalt is oxidized — seal sooner."
    ]
  },
  {
    "key": "siding-wash",
    "title": "Wash the siding",
    "why": "Mildew and dirt shorten paint life and dull curb appeal. A garden-hose soap wash once a year is plenty.",
    "icon": "Construction",
    "tier": "annual",
    "season": "summer",
    "category": "outdoor",
    "time_minutes": 120,
    "difficulty": "moderate",
    "applies_to": { "systems": ["siding"] },
    "supplies": ["Soft-bristle brush on a pole", "House-wash concentrate (oxygen bleach + dish soap blend)", "Garden hose"],
    "steps": [
      "Wet the wall from bottom up (prevents streaks).",
      "Apply soap from bottom up; let it dwell 5 min.",
      "Scrub stubborn spots gently.",
      "Rinse top down."
    ],
    "tips": [
      "Pressure washers can drive water behind vinyl siding. Stick to garden-hose pressure.",
      "Black streaks on the gutter face are usually mildew — same wash handles it."
    ]
  },
  {
    "key": "fence-walk",
    "title": "Walk the fence line",
    "why": "Loose posts and broken pickets multiply if ignored. 30 minutes now is a half-day fix later.",
    "icon": "Fence",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["fence"] },
    "supplies": ["Screws/nails", "Drill"],
    "steps": [
      "Walk the full perimeter.",
      "Push each post — solid posts barely move. Wobbly ones flag rot at the soil line.",
      "Re-screw any loose pickets, replace cracked ones.",
      "Note rotted posts for replacement before storm season."
    ],
    "tips": ["A failed post is much easier to dig out before winter than after one frost cycle."]
  },
  {
    "key": "tree-prune",
    "title": "Prune dead branches",
    "why": "Dormant pruning shapes the tree and removes hazards before spring storms find them for you.",
    "icon": "Scissors",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["woods"] },
    "supplies": ["Hand pruners", "Loppers", "Pole saw for higher branches"],
    "steps": [
      "Late winter to early spring is ideal — before bud break.",
      "Remove dead, damaged, crossing branches first (the 3 Ds).",
      "Cut just outside the branch collar — don't leave stubs.",
      "Step back periodically and check the tree's overall shape."
    ],
    "tips": [
      "Anything over 8 ft up or near power lines = call a certified arborist. The DIY savings aren't worth a fall.",
      "Never 'top' a tree — it kills the tree slowly and ruins the form."
    ]
  },
  {
    "key": "beds-mulch",
    "title": "Mulch the garden beds",
    "why": "Fresh 2–3 inches of mulch holds moisture, regulates root temperature, and smothers weeds before they start.",
    "icon": "Leaf",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["beds"] },
    "supplies": ["Mulch (cu yards: figure bed sq ft × 0.083 for 1-inch depth)", "Wheelbarrow", "Rake"],
    "steps": [
      "Weed first — mulching over weeds just delays the problem.",
      "Edge the bed (creates a crisp visual and slows grass invasion).",
      "Spread 2–3 inches deep. Pull mulch away from trunks — volcano mulching rots bark.",
      "Water it in lightly."
    ],
    "tips": [
      "Hardwood mulch lasts longer than pine bark in most climates.",
      "Dyed mulches look great year 1, fade hard by year 2. Plan accordingly."
    ]
  },
  {
    "key": "outdoor-faucets-winter",
    "title": "Winterize outdoor faucets",
    "why": "Disconnect hoses, shut interior valves, drain. A frozen hose bib is one of the cheapest catastrophes to prevent.",
    "icon": "Snowflake",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 20,
    "difficulty": "easy",
    "keyed_event": "first_frost",
    "days_offset": -14,
    "applies_to": {
      "systems": ["outdoor_faucets"],
      "climate_zones": ["cold-humid", "cold-dry", "mixed-humid", "mixed-dry", "marine"]
    },
    "supplies": ["Insulated faucet covers (optional, $5 each)"],
    "steps": [
      "Disconnect all hoses; drain and store them.",
      "Find the interior shutoff valve for each exterior spigot. Close it.",
      "Open the exterior spigot to drain — leave it open all winter.",
      "Open the small bleeder cap on the interior valve to drain the line between."
    ],
    "tips": [
      "Frost-free sillcocks still freeze if a hose is connected — the hose holds water against the valve.",
      "If you hear water hammer in spring when you turn it on, the line cracked. Easier to fix than it sounds."
    ]
  },
  {
    "key": "garage-door-test",
    "title": "Test garage door safety reverse",
    "why": "Place a 2x4 flat under the door and close. It must reverse on contact — that's the law and the safety.",
    "icon": "ShieldCheck",
    "tier": "quarterly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["garage_opener"] },
    "supplies": ["A 2x4 board"],
    "steps": [
      "Open the door fully.",
      "Lay the 2x4 flat across the threshold.",
      "Hit the close button. The door must stop and reverse the moment it touches the wood.",
      "If it doesn't, do not use the door until adjusted. The opener has a force adjustment screw on the back."
    ],
    "tips": [
      "Test the photo-eye too: wave a broom across the path while the door is closing — it should reverse.",
      "Lubricate hinges and rollers with garage-door spray (NOT WD-40) once a year — quieter operation, much longer life."
    ]
  },
  {
    "key": "garage-door-lube",
    "title": "Lubricate the garage door",
    "why": "Dry rollers, hinges, and springs wear out fast and sound terrible. The right lube doubles the door's quiet life.",
    "icon": "Settings2",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["garage_opener"] },
    "supplies": ["Garage-door lubricant spray (silicone or lithium — NOT WD-40)"],
    "steps": [
      "Close the door. Unplug the opener.",
      "Spray each hinge pivot, each roller bearing, and the springs.",
      "Wipe drips off the rollers (you don't want sticky drips).",
      "Plug back in, cycle the door — it should sound noticeably quieter."
    ],
    "tips": ["Never lube the track itself. Roller bearings yes, track no — debris sticks to the track."]
  },
  {
    "key": "extinguisher-check",
    "title": "Check fire extinguishers",
    "why": "Pressure gauges drift over time and dry chemical settles. A 30-second check confirms the thing will actually work.",
    "icon": "CircleAlert",
    "tier": "annual",
    "season": "any",
    "category": "indoor",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["extinguisher"] },
    "supplies": [],
    "steps": [
      "Check the gauge — needle should be in the green zone.",
      "Pull the pin and tilt the extinguisher upside down for 5 seconds — this loosens settled powder.",
      "Inspect the hose and nozzle for cracks.",
      "If expired (typically 12 years), replace or get it recharged."
    ],
    "tips": [
      "Kitchen: Class K or general-purpose ABC. Garage: ABC. Bedroom: smaller ABC.",
      "Aim at the base of the fire, not the flames. PASS: Pull, Aim, Squeeze, Sweep."
    ]
  },
  {
    "key": "mower-tune",
    "title": "Mower spring tune-up",
    "why": "Sharp blade, fresh oil, new spark plug, and clean air filter — the difference between a season that fights you and one that doesn't.",
    "icon": "Tractor",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["mower"] },
    "supplies": ["Sharp replacement blade (or sharpening kit)", "Oil", "Spark plug", "Air filter"],
    "steps": [
      "Drain old gas. Check oil, drain and refill if dirty.",
      "Disconnect spark plug for safety. Tip mower with the air filter UP.",
      "Remove and sharpen or replace the blade. Balance it.",
      "Replace spark plug and air filter — they're cheap and they matter.",
      "Fresh fuel + stabilizer for the season."
    ],
    "tips": [
      "Sharp blades cut the grass clean; dull blades tear it (turning lawn tips brown).",
      "Use Ethanol-free fuel in small engines whenever possible — way fewer carburetor issues."
    ]
  },
  {
    "key": "mower-storage",
    "title": "Winterize the mower",
    "why": "Old gas turns to varnish in the carburetor — that's the #1 reason mowers won't start in spring.",
    "icon": "Snowflake",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["mower"] },
    "supplies": ["Fuel stabilizer", "Clean rags"],
    "steps": [
      "Option A (preferred): Run the tank dry. Then disconnect the plug and crank a few times.",
      "Option B: Add fuel stabilizer to a full tank, run for 5 minutes to circulate.",
      "Clean grass off the deck (it traps moisture and rusts the deck).",
      "Store with the plug disconnected."
    ],
    "tips": ["Battery-electric mowers: pull the battery and store at ~50% charge somewhere not freezing."]
  },
  {
    "key": "snow-blower-prep",
    "title": "Prep the snow blower",
    "why": "Pre-storm prep beats post-storm troubleshooting. Especially at 5 AM.",
    "icon": "Snowflake",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["snow_blower"] },
    "supplies": ["Fresh fuel + stabilizer", "Skid-shoe and shave-plate spares (optional)"],
    "steps": [
      "Drain any old gas. Refill with fresh fuel + stabilizer.",
      "Check engine oil; change if last done a year ago.",
      "Inspect the belt(s), shear pins, and shave plate.",
      "Test-start before the first storm — not during."
    ],
    "tips": [
      "Buy spare shear pins now. They snap at the worst times, hardware stores are closed Sunday morning.",
      "If the engine bogs in heavy snow, the carb may need a clean — bring it in before December."
    ]
  },
  {
    "key": "generator-monthly-exercise",
    "title": "Exercise the generator",
    "why": "Standby generators must run monthly to keep oil circulated, batteries charged, and the controller responsive.",
    "icon": "Zap",
    "tier": "monthly",
    "season": "any",
    "category": "energy",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["generator"], "system_subtypes": ["standby"] },
    "supplies": [],
    "steps": [
      "Most standby units auto-exercise weekly. Confirm yours did — check the controller log.",
      "If yours doesn't auto-exercise, manually start it for 15 minutes under load (turn on a few breakers).",
      "Listen for unusual noise. Check oil if you hear any."
    ],
    "tips": ["Save the controller log screen as a photo each month. Trend tells you when something's drifting."]
  },
  {
    "key": "generator-annual",
    "title": "Annual generator service",
    "why": "Oil + filter + air filter + spark plug + battery + transfer-switch check. The same hour every year.",
    "icon": "Wrench",
    "tier": "annual",
    "season": "fall",
    "category": "energy",
    "time_minutes": 90,
    "difficulty": "moderate",
    "applies_to": { "systems": ["generator"] },
    "supplies": ["Manufacturer service kit (oil, filter, plug, air filter)"],
    "steps": [
      "Schedule with the install company OR follow the manual exactly if DIY.",
      "Run before-and-after voltage tests at the panel.",
      "Replace battery every 3 years regardless of state — they fail without warning.",
      "Update the controller firmware if applicable."
    ],
    "tips": ["Portable generators: same service intervals, plus run them out of fuel before storage."]
  },
  {
    "key": "battery-backup",
    "title": "Check sump battery backup",
    "why": "The battery dries out and you don't know — until the power goes out during the storm that justified buying it.",
    "icon": "Battery",
    "tier": "biannual",
    "season": "any",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["sump"] },
    "supplies": [],
    "steps": [
      "Unplug the main sump pump.",
      "Pour water into the pit until the backup pump kicks on.",
      "Confirm the alarm sounds (if equipped).",
      "Restore power. Replace the battery every 4–5 years even if it tests OK."
    ],
    "tips": ["A backup pump + battery is one of the highest-ROI items in a finished basement. Worth every penny."]
  },
  {
    "key": "smart-thermostat-firmware",
    "title": "Update smart-thermostat firmware",
    "why": "Bug fixes for schedule, weather data, and home/away detection drop quarterly. Stale firmware can act weirdly.",
    "icon": "Settings2",
    "tier": "quarterly",
    "season": "any",
    "category": "energy",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["thermostat"] },
    "supplies": [],
    "steps": [
      "Open the app. Look for firmware version under device settings.",
      "Compare to current version on the manufacturer's site. Update if behind.",
      "After update, walk through schedule + sensors to confirm nothing reset."
    ],
    "tips": ["Most updates take 5 minutes and auto-restart the thermostat. Don't run in the middle of a heat wave."]
  },
  {
    "key": "solar-clean",
    "title": "Rinse the solar panels",
    "why": "Dust, pollen, and bird droppings drop output 5–25%. A garden-hose rinse in spring usually recovers most of it.",
    "icon": "Sun",
    "tier": "annual",
    "season": "spring",
    "category": "energy",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "systems": ["solar"] },
    "supplies": ["Soft brush on a pole", "Deionized water if hard-water area"],
    "steps": [
      "Early morning, cool panels (never spray hot panels).",
      "Rinse from below, working up.",
      "Soft-brush stubborn spots with mild soap; rinse again."
    ],
    "tips": ["Roof-mounted panels in steep installs: hire it out. Output gain isn't worth a fall."]
  },
  {
    "key": "smoke-battery-annual",
    "title": "Replace all alarm batteries",
    "why": "Even hardwired alarms have backup batteries that die every couple years. 'Daylight Saving' is the famous reminder for this.",
    "icon": "Battery",
    "tier": "annual",
    "season": "fall",
    "category": "indoor",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Fresh 9V or AA batteries (check what yours uses)"],
    "steps": [
      "Walk room by room. Twist each alarm off its base.",
      "Swap the battery, twist back on.",
      "Press test — full alarm means good.",
      "Note the manufacture date on the back; mark a 'replace by [year]' on it (10 years out)."
    ],
    "tips": ["10-year sealed alarms cost a few dollars more and skip this task entirely — worth it on the next replacement."]
  },
  {
    "key": "weatherstripping",
    "title": "Inspect weatherstripping",
    "why": "Door and window seals fail invisibly. Drafts steal a real percentage of your heating and cooling.",
    "icon": "Hammer",
    "tier": "annual",
    "season": "fall",
    "category": "indoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Replacement weatherstrip", "Caulk for cracks", "Dollar bill (for testing seal)"],
    "steps": [
      "Close a door on a dollar bill. Try to pull it out — if it slides easily, the seal is shot.",
      "Repeat for every exterior door.",
      "Look at the weatherstrip itself — cracks, missing chunks, compressed flat = replace.",
      "Caulk any visible gaps around window frames from the inside."
    ],
    "tips": [
      "Garage-to-house door is often the worst offender — and the most important from a CO-safety standpoint.",
      "Foam-core weatherstrip is cheap and easy; rubber bulb is longer-lasting."
    ]
  },
  {
    "key": "caulk-bathrooms",
    "title": "Inspect bathroom caulk",
    "why": "Failed caulk lets water into walls. Water in walls is the most expensive surprise homeowners face.",
    "icon": "PaintBucket",
    "tier": "annual",
    "season": "any",
    "category": "indoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Caulk remover tool", "Mildew-resistant kitchen-and-bath silicone"],
    "steps": [
      "Inspect the perimeter of the tub/shower, around the toilet base, and at sink countertops.",
      "Anywhere mildewed or pulled loose — peel out, clean, dry, recaulk.",
      "Run a thin smooth bead with the tip of a wet finger.",
      "Let cure 24 hours before water exposure."
    ],
    "tips": [
      "Silicone is forever-watertight but won't accept paint. Latex caulk paints but fails near constant water — pick correctly.",
      "Run an exhaust fan during every shower. Bath fan + a closing window = no mildew in the first place."
    ]
  },
  {
    "key": "hvac-replace",
    "title": "Plan for HVAC replacement",
    "why": "Most central systems are end-of-life at 15–20 years. Planning a year ahead means you don't take the first contractor's price.",
    "icon": "Thermometer",
    "tier": "multi-year",
    "years_between": 15,
    "season": "any",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": [],
    "steps": [
      "Note the install year on your unit (data plate).",
      "Around year 13–14: get 2–3 quotes for a comparable replacement (size, SEER, brand).",
      "Look at any utility rebates and federal/state heat-pump credits — they shift the math significantly.",
      "Choose installer first, equipment second. Quality of install matters more than brand."
    ],
    "tips": [
      "If your system fails in July, you'll pay 20–30% more than a planned replacement.",
      "A Manual J load calculation is worth pushing for. Oversized systems short-cycle and humidity stays high."
    ]
  },
  {
    "key": "wh-replace",
    "title": "Plan for water heater replacement",
    "why": "Tanks fail at 8–12 years. A planned swap is half the price of an emergency Saturday call.",
    "icon": "ShowerHead",
    "tier": "multi-year",
    "years_between": 10,
    "season": "any",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["wh"], "system_subtypes": ["tank"] },
    "supplies": [],
    "steps": [
      "Confirm install year from the data plate.",
      "Year 8: get one quote, even if you don't replace yet — establishes your relationship and price.",
      "Year 10–12: replace proactively. Consider tankless or heat-pump as a step up.",
      "After replacement: add a $15 leak alarm at the pan. It pays for itself the first time."
    ],
    "tips": ["A rust streak down the side of the tank or wet floor under it is GTFO-and-call territory — already failed."]
  },
  {
    "key": "roof-replace",
    "title": "Plan for roof replacement",
    "why": "Asphalt: 15–25 years. Metal: 40+. Tile: 50+. Knowing your timeline lets you save for it instead of finance it.",
    "icon": "Home",
    "tier": "multi-year",
    "years_between": 20,
    "season": "any",
    "category": "structure",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["roof"] },
    "supplies": [],
    "steps": [
      "Look up the install date (closing docs, prior inspection, or seller disclosure).",
      "By year 15 on asphalt: ladder up annually after every windstorm. Note granule loss, curling, missing shingles.",
      "Year 17–22: 3 quotes. The roof is also when you upgrade to ice-and-water shield, ridge vents, and a long-life underlayment.",
      "Save the receipts — buyers ask, appraisers care."
    ],
    "tips": ["Insurance often covers storm damage on a roof. Document hailstorms with photos for your records the day they happen."]
  },
  {
    "key": "exterior-paint",
    "title": "Plan for exterior paint",
    "why": "Wood: 5–7 years. Stucco/fiber-cement: 10–15. Vinyl: rarely. Failed paint = bare wood = rot.",
    "icon": "PaintBucket",
    "tier": "multi-year",
    "years_between": 6,
    "season": "summer",
    "category": "structure",
    "time_minutes": 60,
    "difficulty": "easy",
    "applies_to": { "systems": ["siding"] },
    "supplies": [],
    "steps": [
      "Walk the exterior. Look for chalking (white residue), cracking, peeling, especially south-facing walls.",
      "Year 4–5 on wood: spot-prime fading areas to delay full repaint.",
      "Year 5–7: plan a full repaint. Get the prep right — failed paint is almost always failed prep.",
      "Pick a color you can live with at year 7 — repaints aren't a yearly thing."
    ],
    "tips": ["Power-washing too hard before paint drives water behind boards. Lower pressure + good cleaner is the right combo."]
  },
  {
    "key": "windows-clean",
    "title": "Clean windows inside and out",
    "why": "Beyond curb appeal — annual cleaning is also when you spot failed seals (fogged double-panes) and rotting sash.",
    "icon": "SquareDashed",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 120,
    "difficulty": "moderate",
    "applies_to": { "systems": ["windows"] },
    "supplies": ["Window cleaner or vinegar/water", "Microfiber cloths", "Squeegee"],
    "steps": [
      "Inside first. Vacuum the sill and track before wiping.",
      "Outside: hose first, then squeegee top-to-bottom in S-pattern.",
      "Note any fogging between panes — that's a failed thermal seal, eventually a replacement.",
      "Note any soft wood at the sash bottoms — a moisture problem you want to address."
    ],
    "tips": ["Overcast day or evening — sunny windows streak as you wipe."]
  },
  {
    "key": "ev-charger-check",
    "title": "Inspect the EV charger",
    "why": "Outdoor connectors and cables take weather abuse. A 10-minute look catches cracked seals before they fault.",
    "icon": "BatteryCharging",
    "tier": "annual",
    "season": "spring",
    "category": "energy",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["ev_charger"] },
    "supplies": [],
    "steps": [
      "Inspect the J1772/NACS connector for cracks, bent pins, melting.",
      "Inspect the cable jacket end-to-end for nicks.",
      "Open the holster, wipe dust, check for spiders or bug nests.",
      "Test charge to confirm full rate and clean disconnect."
    ],
    "tips": ["GFCI-protected outlets need annual reset/test if your charger is plugged in (vs hardwired)."]
  },
  {
    "key": "propane-tank-check",
    "title": "Check propane tank gauge",
    "why": "Running dry is more annoying than expensive — relighting pilots and a service charge. Quick to avoid.",
    "icon": "Cylinder",
    "tier": "quarterly",
    "season": "any",
    "category": "energy",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["propane_tank"] },
    "supplies": [],
    "steps": [
      "Lift the dome on the tank, read the gauge.",
      "Under 30%? Call for a fill. Most companies have auto-delivery — confirm yours is on.",
      "Inspect the regulator vent for spider blockage."
    ],
    "tips": ["Keep at least 30% reserve in winter — heating loads are unpredictable and delivery lead times grow."]
  },
  {
    "key": "oil-tank-check",
    "title": "Check oil tank level + filter",
    "why": "An empty oil tank is a cold house and a $300 priming service call. Filter changes prevent the same.",
    "icon": "Cylinder",
    "tier": "annual",
    "season": "fall",
    "category": "energy",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["oil_tank"] },
    "supplies": [],
    "steps": [
      "Read the gauge on top of the tank.",
      "Annual: have the inline fuel filter and nozzle replaced during furnace service.",
      "Look at the tank itself — weeping rust at seams is end-of-life. Outdoor tanks freeze; indoor tanks gel less but corrode faster."
    ],
    "tips": ["Above-ground steel tanks fail at the bottom — water condensates from the inside top down. Sweeping/draining helps; replacement at year 20 is normal."]
  },
  {
    "key": "grill-clean-deep",
    "title": "Deep-clean the grill",
    "why": "Carbon and grease buildup are a fire risk and they taint the food. Twice-yearly deep cleans keep it ready.",
    "icon": "Flame",
    "tier": "biannual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["gas_grill"] },
    "supplies": ["Grill brush (wire or bristle-free)", "Degreaser", "Soapy water + sponge"],
    "steps": [
      "Disconnect the tank (gas) or unplug (electric/pellet).",
      "Remove grates and flavor bars/heat shields. Scrub.",
      "Vacuum out the firebox, scrape the burners.",
      "Check the burner tube ports for spiders — they'll block gas and the flame won't light evenly.",
      "Reassemble; do a hot 'burn-off' for 15 min on high before next cook."
    ],
    "tips": ["Cover the grill when off, not when hot. Trapped heat warps powder-coat finishes."]
  },
  {
    "key": "doorbell-transformer",
    "title": "Check the doorbell transformer",
    "why": "Smart doorbells underpowered = motion misses, restarts, dropped clips. Most wired doorbell transformers are too small for video models.",
    "icon": "BellRing",
    "tier": "annual",
    "season": "any",
    "category": "amenity",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["doorbell"] },
    "supplies": ["Voltmeter (optional)"],
    "steps": [
      "Find the transformer (often in the basement, utility closet, or near the electrical panel).",
      "Read the voltage rating — smart doorbells generally want 16V/30VA or higher.",
      "If lower, upgrade. About $25 + a few screws."
    ],
    "tips": ["Don't try to power a smart doorbell off a 10V mechanical-chime-era transformer. It mostly works, until it doesn't."]
  },

  {
    "key": "panel-annual-inspect",
    "title": "Inspect the electrical panel",
    "why": "Warm spots, rust, dust buildup, and tripped-but-not-reset breakers are all early failure signals. A 10-minute look at the panel once a year catches every common issue cheap.",
    "icon": "Zap",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["panel"] },
    "supplies": ["Flashlight", "Phone camera (for the inside photo)"],
    "steps": [
      "Turn the main breaker OFF only if you smell anything burnt or see scorching — otherwise leave it on.",
      "Open the panel door (most just swing). Look for: discoloration, rust, dust, spider webs, loose wires.",
      "Press each breaker handle — they should be solid, not wiggly. Wiggly = worn contacts.",
      "Photograph the inside of the door for your records. Note the panel brand and amperage.",
      "Close it up. If anything looked concerning, snap photos and ask an electrician for a quote."
    ],
    "tips": ["FPE Stab-Lok and Zinsco panels are known fire risks — if that's what you have, replacement is the standard advice. The photo helps an electrician quote without a site visit."]
  },
  {
    "key": "subpanel-annual-inspect",
    "title": "Inspect the sub-panel",
    "why": "Same checks as the main — but sub-panels in garages and additions are more exposed to moisture and temperature swings, so they age faster.",
    "icon": "Zap",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["subpanel"] }
  },
  {
    "key": "minisplit-filter-clean",
    "title": "Wash the mini-split filters",
    "why": "Mini-split heads pull air through reusable mesh filters right at the indoor unit. A clogged filter chokes airflow, freezes the coil, and slashes efficiency 20%+.",
    "icon": "Wind",
    "tier": "monthly",
    "season": "any",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["minisplit"] },
    "supplies": ["Mild dish soap", "Soft brush"],
    "steps": [
      "Open the front cover of each indoor unit.",
      "Slide the filters out — usually a pull-up tab at the top.",
      "Rinse with lukewarm water; gently scrub with mild soap if greasy.",
      "Let them dry COMPLETELY (an hour at least) before reinstalling — wet filters in a running unit mold fast.",
      "Reinstall and close the cover."
    ],
    "tips": ["Set a recurring task per indoor unit. A 4-head mini-split is 4 separate filter chores, not one."]
  },
  {
    "key": "minisplit-coil-clean",
    "title": "Mini-split coil + drain clean",
    "why": "Behind the washable filters lives the actual evaporator coil. Dust and biofilm coat it over the year — it kills efficiency and grows the mildew smell that's a mini-split's worst problem.",
    "icon": "Wind",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 60,
    "difficulty": "hard",
    "applies_to": { "systems": ["minisplit"] },
    "tips": ["DIY coil cleaning kits exist (foam spray + bib) but a pro who's done a thousand of them does it in 45 minutes for ~$150–$200 per head. Worth it for what's behind the cover."]
  },
  {
    "key": "hrv-erv-filter",
    "title": "Swap HRV / ERV filters",
    "why": "These ventilators run 24/7 in many homes — filters load fast. A clogged HRV stops moving air, defeating the whole reason for installing one.",
    "icon": "Fan",
    "tier": "quarterly",
    "season": "any",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["hrv_erv"] },
    "supplies": ["Replacement filters (check size)"],
    "steps": [
      "Pop the front cover off the unit (clips or screws).",
      "Slide both filters out. Most units have a supply filter and an exhaust filter — both matter.",
      "Vacuum any dust on the front of the heat-exchange core. Don't try to disassemble it.",
      "Slide new filters in, close the cover."
    ]
  },
  {
    "key": "hrv-core-clean",
    "title": "Wash HRV / ERV core",
    "why": "Cores collect dust and condensate slime even with new filters. Annual rinse keeps the exchange efficient. Skip it and your ventilation slowly loses 30%+ throughput.",
    "icon": "Droplets",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "systems": ["hrv_erv"] },
    "tips": ["HRV cores rinse with water. ERV cores are paper-based — gentle vacuum only, never water. Check the manual before turning the hose on."]
  },
  {
    "key": "radon-fan-check",
    "title": "Check radon fan manometer",
    "why": "Most radon mitigation systems have a U-tube manometer on the pipe. If the column collapses to even, the fan has failed and the system is doing nothing. Costs 15 seconds to verify.",
    "icon": "Wind",
    "tier": "quarterly",
    "season": "any",
    "category": "safety",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["radon"] },
    "tips": ["Snap a photo of the manometer when the fan is fresh — that's your reference for 'normal.' A flat column means call your installer."]
  },
  {
    "key": "radon-retest",
    "title": "Re-test radon levels",
    "why": "Even with a working fan, radon levels drift. EPA recommends re-testing every 2 years (or after any major foundation or HVAC work). $15 short-term test kit, mail-in lab.",
    "icon": "FlaskConical",
    "tier": "multi-year",
    "years_between": 2,
    "season": "winter",
    "category": "safety",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["radon"] }
  },
  {
    "key": "surge-protector-indicator",
    "title": "Check surge protector indicator",
    "why": "Whole-home surge protectors take hits silently. A status LED is the only way to know yours still has surge capacity left. Skip the check and your next storm finds out the hard way.",
    "icon": "Zap",
    "tier": "annual",
    "season": "spring",
    "category": "energy",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["surge"] },
    "tips": ["After a known surge event (lightning, downed line nearby) — check it that day, not next year."]
  },
  {
    "key": "air-purifier-filter",
    "title": "Replace HEPA / pre-filter",
    "why": "True-HEPA cartridges last 6–12 months at typical use. Pre-filters (the foam wrapper) need vacuuming monthly — they're what stops dust before the HEPA stage clogs.",
    "icon": "Wind",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["air_purifier"] },
    "supplies": ["Replacement HEPA cartridge (check model)"],
    "tips": ["Pet households, wildfire smoke regions, and allergy seasons cut filter life roughly in half."]
  },
  {
    "key": "ro-prefilter-change",
    "title": "Change RO pre-filters",
    "why": "Sediment + carbon pre-filters protect the expensive RO membrane downstream. Skip them and you'll be replacing a $50 membrane every year instead of every 3–5.",
    "icon": "Droplets",
    "tier": "biannual",
    "season": "any",
    "category": "systems",
    "time_minutes": 20,
    "difficulty": "moderate",
    "applies_to": { "systems": ["ro_filter"] },
    "supplies": ["Replacement sediment + carbon filter cartridges", "Filter housing wrench"],
    "tips": ["Bypass the unit (most have a quick-shutoff) before unscrewing — saves a small flood."]
  },
  {
    "key": "ro-membrane-sanitize",
    "title": "Sanitize the RO system",
    "why": "Biofilm grows in the tank and tubing over the year. An annual sanitize cycle keeps the water tasting fresh and the membrane working.",
    "icon": "FlaskConical",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["ro_filter"] }
  },
  {
    "key": "insulation-inspect",
    "title": "Inspect attic insulation",
    "why": "Blown-in cellulose settles. Batt insulation gets compressed by storage. Both lose R-value silently — and the energy bill follows. A 10-minute attic visit every few years catches it.",
    "icon": "Layers",
    "tier": "multi-year",
    "years_between": 5,
    "season": "fall",
    "category": "structure",
    "time_minutes": 20,
    "difficulty": "moderate",
    "applies_to": { "systems": ["insulation"] },
    "tips": ["Look for: bare joists (insulation should cover them), compressed areas, dark dust streaks (air-sealing failure), animal trails."]
  },
  {
    "key": "transfer-switch-exercise",
    "title": "Exercise the transfer switch",
    "why": "An automatic transfer switch that hasn't fired in a year sometimes won't fire when it matters. Manual switches stiffen. A monthly test catches both.",
    "icon": "Power",
    "tier": "quarterly",
    "season": "any",
    "category": "energy",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["transfer_switch"] }
  },
  {
    "key": "backflow-test",
    "title": "Backflow preventer test (certified)",
    "why": "Most municipalities REQUIRE an annual certified backflow test if you have irrigation or a fire system. Missing it doesn't damage the device — but the city fine + the principal-of-the-thing isn't fun.",
    "icon": "Gauge",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "systems": ["backflow"] },
    "tips": ["You can't self-certify — pick a tester from your municipality's approved list. Most charge $80–$150 and submit the paperwork for you."]
  },
  {
    "key": "wood-splitter-service",
    "title": "Service the wood splitter",
    "why": "Hydraulic fluid degrades, filters clog, engine oil ages. A yearly fluid + filter swap is the cheapest way to keep the splitter running for 20+ years instead of 5.",
    "icon": "Axe",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["wood_splitter"] },
    "tips": ["Drain into a pan — hydraulic fluid recycles at most auto-parts stores."]
  },

  {
    "key": "sump-backup-battery-test",
    "title": "Test sump backup battery",
    "why": "Lead-acid backup batteries fail silently. Discover it during the next power outage and you've already got water in the basement. A 5-minute load test catches a dead cell.",
    "icon": "Battery",
    "tier": "biannual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["sump_backup"], "system_subtypes": ["battery"] },
    "steps": [
      "Unplug the main sump pump from its outlet — simulates a power outage.",
      "Pour a bucket of water in the pit.",
      "The backup should kick in within seconds and pump the water out.",
      "Listen for slow / grinding — that's a tired battery.",
      "Plug the main pump back in. Done."
    ],
    "tips": ["Replace the battery every 3–5 years even if it tests OK — they cliff-edge fail."]
  },
  {
    "key": "vapor-barrier-walk",
    "title": "Inspect the crawlspace vapor barrier",
    "why": "Plastic tears, rodents nest, water pools. An annual walk-through catches all three — and saves a sub-floor that's silently rotting.",
    "icon": "Layers",
    "tier": "annual",
    "season": "spring",
    "category": "structure",
    "time_minutes": 20,
    "difficulty": "moderate",
    "applies_to": { "systems": ["vapor_barrier"] },
    "supplies": ["Headlamp", "Heavy-duty plastic patch tape (if you spot rips)"],
    "tips": ["Take photos as you go — it's much easier to compare year-over-year than to remember."]
  },
  {
    "key": "prv-inspect",
    "title": "Check water pressure (PRV)",
    "why": "A failing pressure-reducing valve quietly creeps city pressure into the 80–100 psi range. That's how you get pinhole leaks and burst supply lines. $15 gauge on a hose bib confirms in 30 seconds.",
    "icon": "Gauge",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["prv"] },
    "supplies": ["Water-pressure test gauge (3/4\" hose-bib thread, $15)"],
    "steps": [
      "Screw the gauge onto an outdoor hose bib.",
      "Open the valve fully. Read the static pressure.",
      "Target: 50–60 psi. Acceptable: 40–80 psi.",
      "Above 80 psi means the PRV is failing — schedule replacement."
    ]
  },
  {
    "key": "expansion-tank-check",
    "title": "Check water expansion tank",
    "why": "Expansion tanks have an air-side bladder that fails at 5–10 years. A failed tank stops absorbing pressure spikes — your water heater's T&P valve becomes the relief and starts dripping.",
    "icon": "Cylinder",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["expansion_tank"] },
    "steps": [
      "Knock on the tank with a knuckle. Top half should sound hollow (air), bottom half dull (water).",
      "If both halves sound the same — bladder failed, tank is waterlogged. Replace.",
      "Bonus: check the Schrader valve on top with a tire-pressure gauge. Should match house water pressure ± 5 psi."
    ]
  },
  {
    "key": "sprinkler-controller-program",
    "title": "Update sprinkler schedule",
    "why": "Lawn water needs change with the season — running summer minutes in fall wastes water and stresses the grass. A spring + fall reprogram covers the year.",
    "icon": "Webhook",
    "tier": "biannual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["sprinkler_controller"] },
    "tips": ["Smart controllers (Rachio, Hydrawise) do this automatically — just check that the seasonal adjust is on."]
  },
  {
    "key": "landscape-lighting-spring",
    "title": "Landscape lighting check + bulb swap",
    "why": "Burnt bulbs are the obvious one, but check the cable connections too — corrosion at the wire nuts is the silent killer. Catching it now means the lights actually work all summer.",
    "icon": "Lightbulb",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["landscape_lighting"] },
    "supplies": ["Replacement bulbs (match the spec sticker on the transformer)", "Dielectric grease"],
    "tips": ["LED retrofits drop the wattage so the transformer runs cooler. Worth doing in batches."]
  },
  {
    "key": "hvac-condensate-flush",
    "title": "Flush the AC condensate line",
    "why": "AC condensate lines clog with algae every summer. A clogged line backs water up into the air handler or ceiling — the #1 water-damage claim from HVAC. A 10-minute flush prevents 5 figures of repair.",
    "icon": "Droplet",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["hvac_condensate_line"] },
    "supplies": ["Wet/dry vac", "1 cup distilled white vinegar", "Funnel"],
    "steps": [
      "Find the access tee on the condensate line near the air handler (look for a T-fitting with a removable cap).",
      "Pour 1 cup of vinegar in. Let sit 5 minutes.",
      "Run the AC for 10 minutes to flush through.",
      "Outside, attach the wet/dry vac to the line exit and pull a vacuum for 30 seconds to clear stragglers."
    ],
    "tips": ["Do this BEFORE the first 90° week — not during. A primary-line backup trips the float switch and shuts the AC down on the hottest day of the year."]
  },
  {
    "key": "anode-rod-check",
    "title": "Check the water heater anode rod",
    "why": "The sacrificial anode rod inside a tank water heater corrodes so the tank doesn't. Check at year 3; replace by year 5. A $30 swap doubles tank lifespan ($1,500–2,500 saved).",
    "icon": "Cylinder",
    "tier": "multi-year",
    "season": "any",
    "category": "systems",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "systems": ["anode_rod"] },
    "supplies": ["1-1/16\" socket + breaker bar", "Replacement anode rod (magnesium or aluminum)", "Teflon tape", "Garden hose"],
    "steps": [
      "Cut power (electric) or gas + close the cold-water supply.",
      "Open a hot tap to relieve pressure.",
      "Drain 2 gal via garden hose at the bottom.",
      "Loosen the hex head on top with the breaker bar — uses 1-1/16\".",
      "Pull the rod out (use a segmented rod if you have low headroom).",
      "Wrap the new rod with Teflon tape, install, and snug a quarter-turn past hand-tight."
    ],
    "tips": ["If your hot water smells like rotten eggs, swap a magnesium rod for an aluminum one — the sulfur is reacting with the magnesium."]
  },
  {
    "key": "gfci-monthly-test",
    "title": "Test every GFCI outlet",
    "why": "GFCI outlets save lives but lose function silently. UL recommends a monthly test. Takes 5 minutes; nobody does it.",
    "icon": "Zap",
    "tier": "monthly",
    "season": "any",
    "category": "safety",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": {},
    "steps": [
      "Walk to every GFCI outlet — kitchen, bathrooms, garage, basement, outdoor.",
      "Press TEST. It should pop with an audible click.",
      "Press RESET to restore power.",
      "If TEST doesn't pop, the outlet is failing — replace it (or call an electrician)."
    ],
    "tips": ["Test outdoor GFCIs in dry weather. If a GFCI won't reset after testing, the outlet itself is bad — don't keep trying."]
  },
  {
    "key": "afci-breaker-test",
    "title": "Test AFCI breakers at the panel",
    "why": "AFCI breakers detect arc faults — the cause of most electrical fires. NEC 2017+ requires them on bedroom + living-room circuits. Test biannually so you know they actually work.",
    "icon": "Zap",
    "tier": "biannual",
    "season": "any",
    "category": "safety",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["panel"] },
    "steps": [
      "At the panel, find the breakers with TEST buttons (combo AFCI / AFCI-GFCI).",
      "Press TEST on each — should trip immediately.",
      "Reset the breaker.",
      "If a breaker doesn't trip, replace it (or call an electrician)."
    ],
    "tips": ["Combo AFCI/GFCI breakers test both at once — one button, both protections verified."]
  },
  {
    "key": "garage-door-spring-inspect",
    "title": "Visually inspect garage door springs",
    "why": "Springs counter-balance a 400-lb door. Average lifespan is ~10,000 cycles — about 7 years for a typical family. Failed springs can drop the door on someone.",
    "icon": "Activity",
    "tier": "annual",
    "season": "any",
    "category": "structure",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["garage_door_springs"] },
    "supplies": ["Step stool", "Flashlight"],
    "steps": [
      "Disconnect the opener — pull the red emergency-release cord.",
      "Lift the door halfway by hand. It should stay put.",
      "If the door slams down, the springs are weak.",
      "Look at the springs — any visible coil gaps mean the spring has stretched and needs replacement."
    ],
    "tips": ["NEVER work on torsion springs yourself — the stored energy can kill you. A 30-second visual inspection is free; hiring out the replacement is the only safe path."]
  },
  {
    "key": "garage-door-weatherstrip",
    "title": "Replace garage door weatherstrip",
    "why": "Bottom seal + side-jamb seals keep cold air, water, and rodents out. Old strips fail at 5–10 years; replacement is $15 of vinyl.",
    "icon": "Construction",
    "tier": "multi-year",
    "season": "fall",
    "category": "structure",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "systems": ["garage_opener"] },
    "supplies": ["Bottom seal (T-style or U-style — match your door)", "Utility knife", "Soapy water spray bottle"],
    "steps": [
      "Pull the old strip out of the retainer track.",
      "Cut the new strip to length, leaving 1\" extra.",
      "Wet the retainer track with soapy water (helps the new strip slide in).",
      "Feed the new strip through end to end.",
      "Trim flush at the ends."
    ],
    "tips": ["In snowy regions, glue a small foam block at each end of the bottom seal — keeps wind from peeling the strip back over time."]
  },
  {
    "key": "fridge-water-filter",
    "title": "Replace the fridge water filter",
    "why": "Most fridge filters say replace every 6 months. Past that, the carbon stops adsorbing chlorine + sediment — and biofilm can grow inside the housing.",
    "icon": "Refrigerator",
    "tier": "biannual",
    "season": "any",
    "category": "systems",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["fridge"] },
    "supplies": ["Replacement filter (model-specific — check the panel behind the lower kick plate or top hinge)"],
    "steps": [
      "Twist the old filter out — usually a quarter turn left.",
      "Pop the new one in, twist right until it clicks.",
      "Run 4 gallons through the dispenser to flush carbon dust.",
      "Reset the filter indicator on the control panel."
    ],
    "tips": ["Buy from the manufacturer or a brand with NSF/53 certification. Third-party filters labeled 'compatible' often don't certify lead removal even when they cost more."]
  },
  {
    "key": "fridge-gasket-clean",
    "title": "Clean the fridge door gasket",
    "why": "Door gaskets get sticky from spills and tear at 3–5 years. A torn gasket = $80 + a service call. 10 minutes of cleaning + petroleum jelly fixes 95% of issues.",
    "icon": "Refrigerator",
    "tier": "biannual",
    "season": "any",
    "category": "systems",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "systems": ["fridge"] },
    "supplies": ["Warm soapy water", "Soft cloth", "Petroleum jelly (small dab)"],
    "steps": [
      "Wipe both door gaskets with warm soapy water.",
      "Dry thoroughly.",
      "Rub a thin film of petroleum jelly along the gasket.",
      "Slip a dollar bill in the closed door and pull — should drag with resistance everywhere on the perimeter."
    ],
    "tips": ["The gasket fails first under the freezer door's bottom corners. Clean that spot every time."]
  },
  {
    "key": "dishwasher-spray-arm",
    "title": "Clean the dishwasher spray arm",
    "why": "Spray-arm jets clog with hard-water scale. Plates come out spotty. A 15-minute clean restores washing performance.",
    "icon": "Utensils",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["dw"] },
    "supplies": ["Toothpick or thin wire", "White vinegar", "Screwdriver (if your arm screws on)"],
    "steps": [
      "Unclip or unscrew the spray arm.",
      "Hold up to a light — look for blocked jets.",
      "Poke each blocked jet with the toothpick.",
      "Soak arm in vinegar for 30 minutes.",
      "Reinstall and run an empty hot cycle."
    ],
    "tips": ["Pull the filter at the bottom of the tub while you're in there — most dishwashers have one and most users never clean it."]
  },
  {
    "key": "toilet-flapper-check",
    "title": "Check toilet flappers for silent leaks",
    "why": "A failing flapper is the #1 cause of running toilets and silent water waste — up to 200 gallons per day per toilet, invisible until the bill arrives.",
    "icon": "Droplet",
    "tier": "annual",
    "season": "any",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Food coloring or a toilet dye tablet"],
    "steps": [
      "Lift the tank lid.",
      "Drop 5 drops of food coloring in the tank.",
      "Wait 15 minutes — don't flush.",
      "Look in the bowl. If you see color, the flapper is leaking."
    ],
    "tips": ["Flappers are $5–10. Buy the universal replacement that fits 2\" or 3\" flush valves. Don't try to clean an old one — rubber goes hard and won't seal."]
  },
  {
    "key": "attic-moisture-walk",
    "title": "Walk the attic for moisture / pests",
    "why": "Roof leaks, bath-fan failures, and condensation show up in the attic months before they're visible inside. A flashlight walk catches them while they're cheap.",
    "icon": "Layers",
    "tier": "biannual",
    "season": "spring",
    "category": "structure",
    "time_minutes": 20,
    "difficulty": "moderate",
    "applies_to": { "systems": ["attic_access"], "system_subtypes": ["pull-down", "scuttle", "knee-wall"] },
    "supplies": ["Strong flashlight or headlamp", "Knee pads"],
    "steps": [
      "Walk the perimeter — stay on rafters or planks, never the drywall.",
      "Look for water stains on rafters near valleys + skylights.",
      "Inspect each bath/dryer/range vent — they MUST exit outside, not just into the attic.",
      "Check insulation for matted or dark spots (= past water)."
    ],
    "tips": ["Bring a digital infrared thermometer — cold spots in the insulation show air-sealing opportunities."]
  },
  {
    "key": "water-shutoff-tour",
    "title": "Exercise every water shutoff",
    "why": "Once a year, walk to every shutoff and turn it. Stuck valves seize from disuse — the night you need them is not when you want to find out they're frozen.",
    "icon": "Droplet",
    "tier": "annual",
    "season": "fall",
    "category": "plumbing",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "systems": ["water_main_shutoff"] },
    "steps": [
      "Find the main water shutoff — basement, garage, or curb box.",
      "Quarter-turn closed, then back open.",
      "Repeat at every angle stop (under sinks + toilets) and the water-heater shutoff.",
      "Test a faucet at each point to confirm it actually works."
    ],
    "tips": ["Old gate valves often won't survive this exercise. That's GOOD information — better to know now and budget the swap than fight it during a 2 AM leak."]
  },
  {
    "key": "ceiling-fan-dust",
    "title": "Dust ceiling fan blades",
    "why": "Dust on blades reduces airflow + adds load to the motor. And dust falls on furniture when the fan runs. 5 minutes per fan; high visible payoff.",
    "icon": "Fan",
    "tier": "quarterly",
    "season": "any",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["fans"] },
    "supplies": ["Old pillowcase", "Step stool"],
    "steps": [
      "Slip the pillowcase over each blade.",
      "Pull it off — dust stays inside the case.",
      "Shake the pillowcase out outside."
    ],
    "tips": ["The pillowcase trick beats a duster every time — no dust shower on the floor. Bump to monthly if anyone in the house has allergies."]
  },
  {
    "key": "register-vent-vacuum",
    "title": "Vacuum supply registers + return grilles",
    "why": "Registers + returns pile up dust, hair, and (with pets) fur. Restricted returns choke the HVAC and waste energy.",
    "icon": "Wind",
    "tier": "quarterly",
    "season": "any",
    "category": "systems",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Vacuum with brush attachment", "Screwdriver"],
    "steps": [
      "Remove each register / grille — usually 2–4 screws.",
      "Vacuum the grille and the duct opening behind it.",
      "For returns, vacuum the visible duct as deep as the wand reaches.",
      "Wash particularly grimy grilles in the sink."
    ],
    "tips": ["Phone-photo each register location BEFORE removing it — keeps you from putting a 4-way back where the 1-way belonged."]
  },
  {
    "key": "washer-hose-inspect",
    "title": "Inspect washer supply hoses",
    "why": "Standard rubber washer hoses fail at year 5–8 — flooding the laundry room with city pressure (5 gal/minute). Single biggest plumbing failure homeowners face.",
    "icon": "WashingMachine",
    "tier": "annual",
    "season": "any",
    "category": "indoor",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["washer"] },
    "supplies": ["Flashlight"],
    "steps": [
      "Pull the washer forward enough to see the hoses.",
      "Look for blisters, kinks, or rust around the brass fittings.",
      "Wiggle each connection — should be tight, no drip."
    ],
    "tips": ["Swap rubber hoses for stainless-steel braided (~$15/pair). Different lifespan; same install effort. Single best plumbing upgrade in the house."]
  },
  {
    "key": "under-sink-leak-walk",
    "title": "Under-sink leak walk",
    "why": "Slow leaks rot cabinets + grow mold long before they're visible. A 30-sec look catches them at 'wet paper towel' instead of 'rotted plywood.'",
    "icon": "Droplet",
    "tier": "quarterly",
    "season": "any",
    "category": "plumbing",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Flashlight", "Paper towel"],
    "steps": [
      "Open every cabinet that has water in it.",
      "Shine the flashlight at supply lines + P-traps.",
      "Run the faucet for 10 seconds and look again.",
      "Wipe a paper towel around each joint — wet = leak."
    ],
    "tips": ["Include the ice-maker line (back of fridge), the dishwasher supply, and the toilet supply lines. Three biggest under-the-radar leak sources."]
  },
  {
    "key": "dryer-vent-outside",
    "title": "Check the dryer vent termination",
    "why": "The vent outside often clogs with lint or has the flapper held open by debris. Either kills airflow and risks a dryer fire.",
    "icon": "Wind",
    "tier": "annual",
    "season": "fall",
    "category": "safety",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["dryer"] },
    "supplies": ["Brush", "Ladder if it's roof-vented"],
    "steps": [
      "Find the dryer vent outside.",
      "Verify the flapper opens when the dryer runs and closes when it stops.",
      "Brush out any visible lint from the screen.",
      "If it has a screen, REMOVE it — code prohibits screens because they trap lint."
    ],
    "tips": ["If your vent run exceeds 25 ft of equivalent length, ask an HVAC pro about a booster fan — and double the cleaning cadence."]
  },
  {
    "key": "caulk-bathroom-tub",
    "title": "Re-caulk the bathtub seal",
    "why": "Tub caulk is the most-failed seal in the house. Cracks let water rot the subfloor — eventually dropping the tub.",
    "icon": "Construction",
    "tier": "biannual",
    "season": "any",
    "category": "structure",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": {},
    "supplies": ["Caulk-removal tool", "Painter's tape", "100% silicone (GE Supreme or Loctite POLYSEAMSEAL)", "Caulk gun"],
    "steps": [
      "Score the old caulk with the removal tool.",
      "Pull all of it out — leave no rubber behind.",
      "Tape both edges of the joint cleanly.",
      "Run a thin bead.",
      "Smooth with a wet finger.",
      "Pull the tape immediately.",
      "Don't shower for 24 hours."
    ],
    "tips": ["Most failures are at the front corner of the tub where bodies sit. If you only have time for one spot, do that one."]
  },
  {
    "key": "tree-limbs-over-roof",
    "title": "Inspect tree limbs over the roof",
    "why": "Limbs within 6 ft of the roof drop debris in gutters, scrape shingles in wind, and provide squirrel highways to your attic.",
    "icon": "TreePine",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": { "systems": ["woods"] },
    "supplies": ["Camera with zoom (or binoculars)", "Pruning saw if reachable"],
    "steps": [
      "Walk the full perimeter of the house.",
      "Look up.",
      "Note any limb within 6 ft of the roof, eaves, or chimney.",
      "Trim what you can reach safely.",
      "Schedule an arborist for the rest."
    ],
    "tips": ["Photograph problem limbs from the same angle each year — it's the only way to actually track growth. Arborists are cheaper in winter (off-season)."]
  },
  {
    "key": "driveway-crack-fill",
    "title": "Fill driveway cracks",
    "why": "Cracks let water in. Water freezes, expands, and turns a hairline crack into a pothole. $30 of crack filler buys you 5 years before the next reseal.",
    "icon": "Route",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "systems": ["driveway"], "system_subtypes": ["asphalt"] },
    "supplies": ["Wire brush", "Leaf blower or shop vac", "Crack filler (rubberized cold-pour OR hot-pour caulk tubes)", "Play sand"],
    "steps": [
      "Brush + blow every crack clean.",
      "Pick a dry day above 50°F.",
      "Apply filler — overfill slightly; it shrinks as it cures.",
      "Dust sand on top so it doesn't track onto shoes."
    ],
    "tips": ["Hot-pour filler from a heated caulk gun lasts twice as long as cold-pour bottles. Worth the upgrade if your driveway has many cracks."]
  },
  {
    "key": "hose-bib-cap-on",
    "title": "Drain + cap outdoor faucets for winter",
    "why": "Even after draining + shutoff, a foam cap stops residual water from freezing and cracking the spigot.",
    "icon": "Droplets",
    "tier": "annual",
    "season": "fall",
    "category": "plumbing",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["outdoor_faucets"] },
    "supplies": ["Foam outdoor-faucet cover ($2 each)"],
    "steps": [
      "Turn off the inside shutoff (typically near the basement ceiling).",
      "Open the outside spigot and let it drain.",
      "Leave the spigot OPEN over winter.",
      "Slip a foam cap over the outside."
    ],
    "tips": ["Frost-free spigots don't strictly need this, but it's $2 of insurance. Always disconnect garden hoses — leaving them attached defeats the frost-free design."]
  },
  {
    "key": "breaker-panel-touch",
    "title": "Touch-test the breaker panel",
    "why": "Loose breaker connections heat up + fail. A bare-hand test (panel cover on) catches the warm ones before they catch fire.",
    "icon": "Zap",
    "tier": "annual",
    "season": "any",
    "category": "safety",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["panel"] },
    "steps": [
      "Lightly touch each breaker handle with the back of your hand.",
      "All should feel the same temperature.",
      "Any breaker noticeably warmer than its neighbors = call an electrician."
    ],
    "tips": ["If you smell anything like burning plastic at the panel, leave the house. Call the fire department first, the electrician second. Don't open the panel cover yourself."]
  },
  {
    "key": "mailbox-inspect",
    "title": "Inspect mailbox + house numbers",
    "why": "Post rots at the ground line. Door hinge fails. House numbers fade. Three small jobs that surface during the winter cleanup.",
    "icon": "Construction",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Drill", "Replacement door hinge / numbers if needed"],
    "steps": [
      "Push the post sideways — should be solid.",
      "Open + close the door — hinge tight?",
      "Check house numbers from the street for visibility (emergency services lookup)."
    ],
    "tips": ["Reflective house numbers (not just paint) are required by most fire-department response standards."]
  },
  {
    "key": "solar-production-check",
    "title": "Check solar production vs last year",
    "why": "Solar panels degrade ~0.5%/year normally. A 10%+ drop month-over-month signals a failed micro-inverter or string fault — call the installer.",
    "icon": "Sun",
    "tier": "monthly",
    "season": "any",
    "category": "energy",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["solar"] },
    "steps": [
      "Open the monitoring app (Enphase, SolarEdge, Tesla, SunPower).",
      "Compare this month vs same month last year.",
      "Look at per-panel production — any panel under 80% of peers = call the installer."
    ],
    "tips": ["Compare year-over-year same-month, not month-over-month — clouds skew month-over-month and waste your worry."]
  },
  {
    "key": "septic-additive-skip",
    "title": "Skip septic additives — they don't work",
    "why": "Septic 'helper' additives sold at hardware stores don't work — EPA + most extension programs say so. This task is a 'reminder NOT to do something' AND a one-time learning task.",
    "icon": "Info",
    "tier": "annual",
    "season": "any",
    "category": "plumbing",
    "time_minutes": 5,
    "difficulty": "easy",
    "applies_to": { "systems": ["septic"] },
    "steps": [
      "If you've been buying additives, stop.",
      "The bacteria in a healthy septic are already there.",
      "What actually hurts septic: chlorine bleach in volume, antibacterials, paint, solvents, grease."
    ],
    "tips": ["Spend the additive money on a 3-year pump-out instead. That's the actual maintenance lever."]
  },
  {
    "key": "wood-pile-relocate",
    "title": "Move firewood 30 ft from the house",
    "why": "Stacked wood against the house = termite highway + carpenter ant motel. Code recommends 30 ft from the structure on a rack or dry ground.",
    "icon": "Axe",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "moderate",
    "applies_to": { "has_woodfire": true },
    "supplies": ["Wheelbarrow"],
    "steps": [
      "Move firewood 30+ ft from the house.",
      "Stack on a rack (off the ground).",
      "Keep the top covered; leave the sides open for airflow.",
      "Burn the oldest wood first (first-in, first-out)."
    ],
    "tips": ["If you must store close (cold-climate reality), keep ONE day's worth at a time on a metal rack on the porch. The other 95% lives at distance."]
  },
  {
    "key": "hvac-coil-clean",
    "title": "Clean the outdoor AC condenser coil",
    "why": "Outdoor coils clog with lawn clippings, pollen, dryer lint, and cottonwood seed. A clogged coil makes the compressor work harder — shorter life + higher bill.",
    "icon": "Fan",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": {},
    "supplies": ["Garden hose", "Fin comb", "Coil cleaner spray (foaming)"],
    "steps": [
      "Cut power at the disconnect (the gray box next to the unit).",
      "Rinse from inside out with the garden hose (low pressure).",
      "Spray foaming cleaner per directions; wait 10 minutes.",
      "Rinse again.",
      "Straighten any bent fins gently with the fin comb."
    ],
    "tips": ["Do this BEFORE the first 90° week, not during. The day everyone's AC dies is not the day to be outside cleaning yours."]
  },
  {
    "key": "emergency-card-print",
    "title": "Print + post the Emergency Card",
    "why": "A single sheet listing every shutoff location, breaker map, and pro phone number. Tape inside a cabinet. Works when the phone is dead — which is when you'll need it most.",
    "icon": "FileText",
    "tier": "annual",
    "season": "any",
    "category": "safety",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "is_first_time": true },
    "supplies": ["Printer", "Sharpie"],
    "steps": [
      "Use Homestead's 'Emergency Card' export.",
      "Print it.",
      "Tape inside the laundry-room cabinet or the inside of the breaker-panel door."
    ],
    "tips": ["Update annually — phone numbers churn and vendors retire. Photo copies aren't searchable; paper is."]
  },
  {
    "key": "salt-creep-rinse",
    "title": "Rinse salt creep off concrete + foundation",
    "why": "Road salt + sidewalk de-icer eats concrete, kills foundation landscaping, and corrodes door thresholds. A spring rinse undoes most of the damage.",
    "icon": "Droplets",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "has_heavy_snow": true },
    "supplies": ["Garden hose with spray nozzle"],
    "steps": [
      "Wait for daytime temps to stay above 40°F.",
      "Rinse the driveway approach + sidewalks.",
      "Rinse the foundation perimeter 3 ft out.",
      "Pay extra attention to the garage door threshold + front-door threshold."
    ],
    "tips": ["If you have a dog, also rinse paws after every walk during salt season — calcium chloride burns paw pads. A wet towel by the door beats a vet bill."]
  },

  {
    "key": "storm.hurricane-season-prep",
    "title": "Hurricane season pre-prep walk",
    "why": "Atlantic season opens June 1. A 30-minute walk now — tighten loose siding, photograph the exterior, check window-shutter latches — beats scrambling 48 hours out from a named storm.",
    "icon": "Wind",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["hurricane"] },
    "supplies": ["Phone camera", "Notepad", "Tape measure"],
    "steps": [
      "Walk the exterior on June 1 (or as close as the weekend allows).",
      "Photograph every elevation — useful for an insurance claim.",
      "Tighten any loose siding, fascia, or soffit panels you can reach safely.",
      "Test that every storm-shutter latch closes and locks.",
      "Note anything that needs a pro fix while you still have weeks, not hours."
    ],
    "tips": ["Save the photos to a cloud folder labeled with the date — claims adjusters ask for time-stamped pre-loss photos."]
  },
  {
    "key": "storm.hurricane-kit-refresh",
    "title": "Refresh the hurricane kit",
    "why": "Batteries die. Water bottles leach plastic. Cash gets spent. An annual refresh keeps the kit actually useful when the power's out for 5 days.",
    "icon": "Package",
    "tier": "annual",
    "season": "spring",
    "category": "safety",
    "time_minutes": 45,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["hurricane"] },
    "supplies": ["Bottled water (1 gal per person per day x 7 days)", "Battery-powered radio", "Flashlight + spare batteries", "First-aid kit", "Manual can opener", "Cash in small bills", "Phone power banks"],
    "steps": [
      "Empty the kit on the garage floor. Check expiration dates on water, food, meds.",
      "Replace anything within 6 months of expiry.",
      "Top up cash (~$200 in small bills — ATMs don't work in outages).",
      "Charge every power bank and label its capacity with a Sharpie.",
      "Pack back in a single labeled bin, store by the most-used exit."
    ],
    "tips": ["7 days of water sounds excessive until day 4 of a regional outage. Don't cut this number."]
  },
  {
    "key": "storm.hurricane-tree-limb-clearance",
    "title": "Clear tree limbs over the roof + powerlines",
    "why": "The single biggest cause of hurricane home damage in tree-rich neighborhoods is a limb that was already weak. A pre-season trim is the cheapest insurance you can buy.",
    "icon": "Trees",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "region_hazards": ["hurricane"] },
    "tips": ["Limbs touching power lines are the utility's responsibility — call them, don't climb. Anything over the roof is yours."]
  },
  {
    "key": "storm.hurricane-insurance-windstorm-review",
    "title": "Review insurance — windstorm + deductible",
    "why": "Wind/named-storm deductibles in coastal states can be 2-5% of dwelling coverage — meaning a $400k home has a $20k deductible before insurance pays a dime. Know the number before the storm.",
    "icon": "ShieldCheck",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["hurricane"] },
    "steps": [
      "Pull up your declarations page.",
      "Find the 'Windstorm' or 'Named storm' deductible (usually a percentage, not a dollar amount).",
      "Multiply by your dwelling coverage — that's your real deductible.",
      "If the number surprises you, call your agent. Sometimes you can buy it down."
    ]
  },
  {
    "key": "storm.hurricane-sump-backup-test",
    "title": "Test the sump pump battery backup",
    "why": "When a hurricane knocks out power and dumps 8 inches of rain, the primary sump is useless. The battery backup is what keeps the basement dry.",
    "icon": "BatteryCharging",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["hurricane", "flood"] },
    "steps": [
      "Unplug the primary sump pump from wall power.",
      "Pour a 5-gallon bucket of water into the sump pit.",
      "Confirm the backup pump engages and clears the pit.",
      "Check the battery date — replace every 5 years even if it tests fine."
    ]
  },
  {
    "key": "storm.hurricane-shutter-pre-fit",
    "title": "Pre-fit storm shutters / panels",
    "why": "Dry-fitting panels in calm weather catches stripped wing-nut anchors and bent tracks — issues you cannot solve at 36 hours out with the hardware store sold out.",
    "icon": "PanelTop",
    "tier": "annual",
    "season": "spring",
    "category": "structure",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "region_hazards": ["hurricane"] },
    "tips": ["Label each panel with the window it fits (Sharpie + masking tape). 'WINDOW 4 - FRONT LEFT BEDROOM' beats 'figuring it out in the wind'."]
  },

  {
    "key": "storm.tornado-shelter-refresh",
    "title": "Refresh the tornado shelter",
    "why": "A tornado warning gives you 5-10 minutes. The shelter spot needs to be obvious, clear, and stocked — not buried under Christmas decorations.",
    "icon": "ShieldAlert",
    "tier": "annual",
    "season": "spring",
    "category": "safety",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["tornado"] },
    "steps": [
      "Confirm the lowest interior room (basement, interior bathroom, or closet) is clear.",
      "Stock with helmets (yes, bike helmets count), shoes, flashlights, and a whistle.",
      "Run a 'drill' — time how long it takes everyone in the house to get there.",
      "Update the family group text with the spot and the drill time."
    ],
    "tips": ["Most tornado injuries are from flying debris hitting the head. Helmets for every person in the house is the cheapest survival upgrade you can make."]
  },
  {
    "key": "storm.tornado-radio-battery",
    "title": "Test the storm radio + swap batteries",
    "why": "The OS pushes phone alerts but phone alerts don't wake a sleeping family. A weather radio with a fresh battery and SAME (county-targeted) alert does.",
    "icon": "Radio",
    "tier": "annual",
    "season": "spring",
    "category": "safety",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["tornado"] },
    "tips": ["NOAA-compatible radios (S.A.M.E.) let you filter to just your county so you're not woken up by warnings 4 counties away."]
  },
  {
    "key": "storm.tornado-emergency-contact-card",
    "title": "Update the emergency contact card",
    "why": "If the house is gone, you and your family need an out-of-state contact everyone calls. Pick the person. Write the number. Put it in every wallet.",
    "icon": "Contact",
    "tier": "annual",
    "season": "spring",
    "category": "safety",
    "time_minutes": 15,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["tornado"] }
  },

  {
    "key": "storm.wildfire-defensible-space",
    "title": "Defensible space — Zones 0/1/2 walk",
    "why": "Embers can travel a mile from a fire front. The 30/100/200 ft zones around the house are the difference between a near-miss and a total loss.",
    "icon": "Flame",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 120,
    "difficulty": "moderate",
    "applies_to": { "region_hazards": ["wildfire"] },
    "steps": [
      "Zone 0 (0-5 ft): nothing flammable touching the house. No mulch, no woodpiles, no juniper.",
      "Zone 1 (5-30 ft): low, well-watered plants only. Prune limbs 10 ft above ground.",
      "Zone 2 (30-100 ft): break up fuel continuity. 10 ft between tree canopies.",
      "Zone 3 (100-200 ft): same goals at lower intensity. Remove dead/dying brush."
    ],
    "tips": ["CalFire's free home assessment is excellent if you live in a high-fire-severity zone — they'll walk the property with you for free."]
  },
  {
    "key": "storm.wildfire-ember-vent-check",
    "title": "Verify ember-resistant vents",
    "why": "Most homes lost to wildfire weren't burned by the fire front — they were ignited by embers entering through attic + crawlspace vents. 1/8 inch mesh is the standard.",
    "icon": "Wind",
    "tier": "annual",
    "season": "spring",
    "category": "structure",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["wildfire"] },
    "tips": ["If you're replacing vents, look for WUI-rated (Wildland-Urban Interface) products certified to ASTM E2886."]
  },
  {
    "key": "storm.wildfire-gutter-clean-extra",
    "title": "Mid-summer gutter + roof debris clean",
    "why": "Dry pine needles + leaf litter on the roof or in gutters are kindling for the next ember. Standard fall gutter clean isn't enough in fire country — a mid-summer pass is critical.",
    "icon": "Wrench",
    "tier": "annual",
    "season": "summer",
    "category": "outdoor",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "region_hazards": ["wildfire"] }
  },
  {
    "key": "storm.wildfire-firepit-grill-clearance",
    "title": "Clear 10 ft around fire pit + grill",
    "why": "Most homeowner-caused wildfires start with a backyard ember. Bare mineral soil 10 ft around any heat source dramatically lowers ignition risk.",
    "icon": "Flame",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["wildfire"] }
  },

  {
    "key": "storm.earthquake-furniture-strap-audit",
    "title": "Heavy-furniture strap audit",
    "why": "The leading cause of earthquake injury (and death, for kids) inside a house is unsecured furniture tipping. Bookshelves, dressers, water heaters, TVs.",
    "icon": "Anchor",
    "tier": "annual",
    "season": "any",
    "category": "safety",
    "time_minutes": 60,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["earthquake"] },
    "supplies": ["Furniture straps (nylon or metal)", "Stud finder", "Drill"],
    "steps": [
      "Identify every piece of furniture taller than it is wide.",
      "Strap it to wall studs. NOT drywall anchors — they'll rip out.",
      "Special attention to bedroom dressers + bookshelves above sleeping spots.",
      "Confirm the TV is strapped or bracketed to the wall."
    ]
  },
  {
    "key": "storm.earthquake-water-heater-strap",
    "title": "Inspect water heater straps",
    "why": "An untethered water heater that falls in a quake usually breaks the gas line — which then becomes the source of the post-quake house fire.",
    "icon": "Flame",
    "tier": "annual",
    "season": "any",
    "category": "systems",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["earthquake"] },
    "tips": ["Code in California requires two straps — upper third and lower third of the tank. Most pre-1980s homes have none or one."]
  },
  {
    "key": "storm.earthquake-gas-shutoff-wrench",
    "title": "Confirm gas-shutoff wrench location",
    "why": "After a quake, you may need to shut off gas at the meter. Doing that with the right wrench takes 10 seconds. Without it, you wait for the utility — for hours or days.",
    "icon": "Wrench",
    "tier": "annual",
    "season": "any",
    "category": "safety",
    "time_minutes": 10,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["earthquake"] },
    "tips": ["The wrench should be ZIP-TIED to the gas meter or hanging on a nail right next to it. Inside a junk drawer is too far when the floor is moving."]
  },
  {
    "key": "storm.earthquake-supply-kit-rotate",
    "title": "Rotate the earthquake supply kit",
    "why": "Aftershocks and infrastructure damage mean you may be on your own for 72+ hours. The kit needs water, food, meds, shoes (broken glass), and cash — all current.",
    "icon": "Package",
    "tier": "annual",
    "season": "any",
    "category": "safety",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["earthquake"] }
  },

  {
    "key": "storm.flood-basement-valuables-off-floor",
    "title": "Move basement valuables off the floor",
    "why": "An inch of basement water totals everything sitting on the slab. Cheap pallets or wire shelving 6 inches up is the cheapest insurance you'll ever buy.",
    "icon": "PackageOpen",
    "tier": "annual",
    "season": "spring",
    "category": "structure",
    "time_minutes": 60,
    "difficulty": "moderate",
    "applies_to": { "region_hazards": ["flood"] }
  },
  {
    "key": "storm.flood-insurance-review",
    "title": "Review flood insurance — FEMA 30-day rule",
    "why": "Standard homeowners doesn't cover flood. NFIP flood policies have a 30-day waiting period — meaning buying coverage when a storm appears on the forecast is too late.",
    "icon": "ShieldCheck",
    "tier": "annual",
    "season": "spring",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["flood"] },
    "steps": [
      "Confirm you have an active flood policy (NFIP or private).",
      "Check the effective date — the 30-day waiting period kills last-minute coverage.",
      "Re-check coverage limits vs current dwelling + contents replacement cost.",
      "If you don't have flood, get a quote — it's usually $400-$700/yr outside high-risk zones."
    ]
  },
  {
    "key": "storm.flood-foundation-grading-check",
    "title": "Foundation grading + downspout check",
    "why": "The fastest, cheapest flood prevention is keeping water moving AWAY from the foundation. 6 inches of fall in the first 10 feet is the rule.",
    "icon": "Mountain",
    "tier": "annual",
    "season": "spring",
    "category": "outdoor",
    "time_minutes": 45,
    "difficulty": "moderate",
    "applies_to": { "region_hazards": ["flood"] },
    "tips": ["Downspout extensions should dump at least 6 ft from the foundation. Splash blocks alone aren't enough in a heavy rain."]
  },

  {
    "key": "storm.ice-heat-tape-test",
    "title": "Test heat tape on exposed pipes + gutters",
    "why": "Heat tape that worked last winter may not work this winter — they fail silently. A 30-second power-on test in October beats a burst pipe in January.",
    "icon": "Zap",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["ice-storm"] },
    "steps": [
      "Locate every heat-tape circuit (under-sink pipes, exposed gutter runs, roof eaves).",
      "Plug in and feel for warmth within 5 minutes.",
      "Replace any segment that doesn't warm up — the wire is dead, not just the thermostat.",
      "Check the GFCI hasn't tripped on the outdoor outlets."
    ]
  },
  {
    "key": "storm.ice-generator-exercise",
    "title": "Exercise the generator",
    "why": "Ice storms cause days-long regional outages. A generator that hasn't run in 11 months frequently won't start — old gas + varnished carb + dead battery.",
    "icon": "Zap",
    "tier": "annual",
    "season": "fall",
    "category": "systems",
    "time_minutes": 30,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["ice-storm"] },
    "steps": [
      "Pull the generator out, top off fresh fuel + stabilizer.",
      "Start it, run under load (plug in a space heater) for 20 minutes.",
      "Confirm the transfer switch + extension cords are where you remembered.",
      "Note the runtime hours; schedule the next oil change accordingly."
    ]
  },
  {
    "key": "storm.ice-tree-powerline-photo",
    "title": "Photograph tree branches over power lines",
    "why": "Branches that crack under ice load are the #1 cause of multi-day outages. Send the photo to your utility — they trim free, and they prioritize lines with documented risk.",
    "icon": "Camera",
    "tier": "annual",
    "season": "fall",
    "category": "outdoor",
    "time_minutes": 20,
    "difficulty": "easy",
    "applies_to": { "region_hazards": ["ice-storm"] },
    "tips": ["Most utilities have a 'report a tree' web form. Photo + address gets it on the trim list."]
  }
]
